import React from 'react'

const loginImage = () => {
    return (
        <svg
            width="8944"
            height="6044"
            viewBox="0 0 8944 6044"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M690.931 5224.51C690.931 5224.51 525.364 3367.96 1417.21 2851.4C2309.06 2332.62 3017.69 2851.4 3017.69 2851.4C3017.69 2851.4 3693.2 3323.81 4130.29 2659.34C4567.39 1992.66 5487.94 544.508 6540.94 955.112C7593.94 1367.92 8269.45 2378.98 8505.66 3122.93C8741.87 3866.87 8435.02 5153.87 8435.02 5153.87C8435.02 5153.87 7944.94 5233.34 7651.34 5239.97C7355.52 5246.59 690.931 5224.51 690.931 5224.51Z"
                fill="var(--surface-a)"
            />
            <path
                d="M8713.22 5222.37C8713.22 5222.37 8792.69 4436.48 8360.01 4213.52C7927.33 3990.56 7582.96 4213.52 7582.96 4213.52C7582.96 4213.52 7254.03 4416.61 7042.11 4129.63C6830.18 3842.65 6382.05 3220.12 5869.9 3398.93C5357.75 3575.54 5028.82 4010.42 4916.24 4330.52C4801.44 4650.61 4951.56 5202.5 4951.56 5202.5C4951.56 5202.5 5189.97 5237.82 5333.46 5240.03C5474.75 5242.24 8713.22 5222.37 8713.22 5222.37Z"
                fill="#E2E2ED"
            />
            <path
                opacity="0.12"
                d="M2490.35 921.331C2509.71 700.28 2346.2 505.393 2125.15 486.039C1904.1 466.684 1709.21 630.191 1689.86 851.241C1670.5 1072.29 1834.01 1267.18 2055.06 1286.53C2276.11 1305.89 2471 1142.38 2490.35 921.331Z"
                fill="#282856"
            />
            <path
                d="M2465.29 873.566C2479.34 652.117 2311.21 461.208 2089.76 447.16C1868.31 433.112 1677.4 601.243 1663.35 822.693C1649.3 1044.14 1817.43 1235.05 2038.88 1249.1C2260.33 1263.15 2451.24 1095.02 2465.29 873.566Z"
                fill="black"
            />
            <path
                d="M2444.87 941.058C2496 730.161 2366.48 517.746 2155.58 466.617C1944.68 415.488 1732.27 545.005 1681.14 755.902C1630.01 966.799 1759.53 1179.21 1970.43 1230.34C2181.32 1281.47 2393.74 1151.95 2444.87 941.058Z"
                fill="black"
            />
            <path
                d="M2404.08 849.157C2404.08 1036.8 2251.76 1189.12 2064.12 1189.12C2059.7 1189.12 2055.29 1189.12 2050.87 1189.12C2026.59 1189.12 2004.51 1184.7 1982.44 1180.29C1947.12 1171.46 1916.21 1158.21 1885.31 1140.55C1876.48 1136.14 1867.65 1129.52 1861.02 1122.89C1823.5 1094.2 1790.38 1056.67 1766.1 1014.72C1755.06 992.648 1744.02 970.573 1737.4 946.29C1730.78 922.007 1726.36 897.723 1724.16 873.44C1724.16 866.817 1724.16 857.987 1724.16 851.364C1724.16 838.119 1724.16 824.874 1726.36 811.629C1730.78 765.27 1746.23 721.119 1768.31 683.591C1799.21 630.61 1841.16 588.666 1894.14 557.76C1933.87 535.685 1975.82 520.233 2022.18 515.818C2035.42 513.61 2048.67 513.609 2061.91 513.609C2068.53 513.609 2077.36 513.609 2083.99 513.609C2108.27 515.817 2134.76 520.233 2156.84 526.855C2181.12 533.478 2203.19 544.516 2225.27 555.553C2267.21 579.836 2304.74 610.742 2333.44 650.478C2340.06 659.308 2344.48 665.93 2351.1 674.76C2368.76 703.458 2384.21 736.572 2390.84 771.893C2395.25 793.968 2399.67 816.043 2399.67 840.326C2404.08 840.326 2404.08 844.742 2404.08 849.157Z"
                fill="white"
            />
            <path
                d="M2064.13 506.977C2165.68 506.977 2256.19 551.127 2318 619.561C2300.34 604.108 2280.47 588.656 2258.39 577.618C2218.66 555.543 2176.72 540.09 2128.15 535.674C2114.9 533.467 2101.66 533.467 2088.41 533.467C2081.79 533.467 2072.96 533.467 2066.34 533.467C2042.06 535.675 2015.56 540.09 1993.49 546.712C1969.21 553.335 1947.13 564.372 1925.05 575.41C1883.11 599.693 1845.58 630.6 1816.88 670.336C1810.26 679.166 1805.85 685.788 1799.22 694.618C1781.56 723.316 1766.11 756.43 1759.49 791.751C1755.07 813.827 1750.66 835.901 1750.66 860.185C1750.66 864.6 1750.66 869.014 1750.66 873.429C1750.66 961.731 1783.77 1041.2 1838.96 1100.81C1770.53 1039 1726.38 948.487 1726.38 846.94C1724.17 659.298 1876.49 506.977 2064.13 506.977Z"
                fill="#D3D3E5"
            />
            <path
                d="M1803.65 842.517C1803.65 844.725 1803.65 846.932 1803.65 849.139C1803.65 851.347 1803.65 853.554 1803.65 855.762C1803.65 857.969 1801.45 860.177 1799.24 860.177H1766.13C1763.92 860.177 1761.71 857.969 1761.71 855.762V844.724C1761.71 842.517 1763.92 840.309 1766.13 840.309H1799.24C1801.45 838.101 1803.65 840.31 1803.65 842.517Z"
                fill="black"
            />
            <path
                d="M1768.29 853.573V844.742H1796.99C1796.99 846.95 1796.99 851.365 1796.99 853.573H1768.29Z"
                fill="white"
            />
            <path
                d="M2364.33 842.568V853.605C2364.33 855.813 2362.13 858.021 2359.92 858.021H2326.81C2324.6 858.021 2322.39 855.813 2322.39 853.605C2322.39 851.398 2322.39 849.191 2322.39 846.983C2322.39 844.776 2322.39 842.567 2322.39 840.359C2322.39 838.152 2324.6 835.945 2326.81 835.945H2359.92C2362.13 838.153 2364.33 840.36 2364.33 842.568Z"
                fill="black"
            />
            <path
                d="M2329.16 853.573C2329.16 851.365 2329.16 846.95 2329.16 844.742H2357.85V853.573H2329.16Z"
                fill="white"
            />
            <path
                d="M2073.04 551.138V584.251C2073.04 586.459 2070.83 588.667 2068.62 588.667C2066.41 588.667 2064.21 588.667 2062 588.667C2059.79 588.667 2057.58 588.667 2055.38 588.667C2053.17 588.667 2050.96 586.459 2050.96 584.251V551.138C2050.96 548.93 2053.17 546.723 2055.38 546.723H2066.41C2070.83 548.93 2073.04 548.93 2073.04 551.138Z"
                fill="black"
            />
            <path
                d="M2068.61 582.055C2066.4 582.055 2061.99 582.055 2059.78 582.055V553.355H2068.61V582.055Z"
                fill="white"
            />
            <path
                d="M2068.66 1109.65C2070.87 1109.65 2073.08 1111.86 2073.08 1114.06V1147.18C2073.08 1149.38 2070.87 1151.59 2068.66 1151.59H2057.63C2055.42 1151.59 2053.21 1149.38 2053.21 1147.18V1114.06C2053.21 1111.86 2055.42 1109.65 2057.63 1109.65C2059.83 1109.65 2062.04 1109.65 2064.25 1109.65C2066.46 1109.65 2068.66 1109.65 2068.66 1109.65Z"
                fill="black"
            />
            <path
                d="M2059.78 1142.74V1114.04C2061.99 1114.04 2066.4 1114.04 2068.61 1114.04V1142.74H2059.78Z"
                fill="white"
            />
            <path
                d="M1929.58 1072.11C1933.99 1074.32 1936.2 1076.53 1940.62 1078.73C1942.82 1078.73 1942.82 1083.15 1942.82 1083.15L1927.37 1111.85C1927.37 1114.05 1922.96 1114.05 1922.96 1114.05L1911.92 1107.43C1909.71 1107.43 1909.71 1103.02 1909.71 1103.02L1925.16 1074.32C1925.16 1072.11 1927.37 1069.9 1929.58 1072.11Z"
                fill="black"
            />
            <path
                d="M1914.03 1103.06L1927.28 1078.78C1929.48 1080.99 1931.69 1080.99 1933.9 1083.2L1920.65 1107.48L1914.03 1103.06Z"
                fill="white"
            />
            <path
                d="M2218.77 595.26L2203.32 623.958C2203.32 626.166 2198.9 626.167 2198.9 626.167C2194.49 623.959 2192.28 621.75 2187.86 619.543C2185.66 619.543 2185.66 615.129 2185.66 615.129L2201.11 586.43C2201.11 584.222 2205.52 584.223 2205.52 584.223L2216.56 590.845C2220.98 590.845 2220.98 595.26 2218.77 595.26Z"
                fill="black"
            />
            <path
                d="M2198.8 619.581C2196.6 617.373 2194.39 617.374 2192.18 615.167L2205.43 590.883L2212.05 595.298L2198.8 619.581Z"
                fill="white"
            />
            <path
                d="M1925.12 586.43L1940.57 615.129C1940.57 617.336 1940.57 619.543 1938.37 619.543C1933.95 621.75 1931.74 623.959 1927.33 626.167C1925.12 628.374 1922.91 626.166 1922.91 623.958L1907.46 595.26C1907.46 593.053 1907.46 590.845 1909.67 590.845L1920.71 584.223C1920.71 584.223 1922.91 584.222 1925.12 586.43Z"
                fill="black"
            />
            <path
                d="M1914.03 595.298L1920.65 590.883L1933.9 615.167C1931.69 617.374 1929.48 617.373 1927.28 619.581L1914.03 595.298Z"
                fill="white"
            />
            <path
                d="M2218.65 1107.43L2207.61 1114.05C2205.4 1114.05 2203.19 1114.05 2203.19 1111.85L2187.74 1083.15C2187.74 1080.94 2187.74 1078.73 2189.95 1078.73C2194.36 1076.53 2196.57 1074.32 2200.99 1072.11C2203.19 1069.9 2205.4 1072.11 2205.4 1074.32L2220.86 1103.02C2220.86 1103.02 2220.86 1105.22 2218.65 1107.43Z"
                fill="black"
            />
            <path
                d="M2192.18 1080.95C2194.39 1078.74 2196.6 1078.74 2198.8 1076.53L2212.05 1100.82L2205.43 1105.23L2192.18 1080.95Z"
                fill="white"
            />
            <path
                d="M1925.12 586.43L1940.57 615.129C1940.57 617.336 1940.57 619.543 1938.37 619.543C1933.95 621.75 1931.74 623.959 1927.33 626.167C1925.12 628.374 1922.91 626.166 1922.91 623.958L1907.46 595.26C1907.46 593.053 1907.46 590.845 1909.67 590.845L1920.71 584.223C1920.71 584.223 1922.91 584.222 1925.12 586.43Z"
                fill="black"
            />
            <path
                d="M1914.03 595.298L1920.65 590.883L1933.9 615.167C1931.69 617.374 1929.48 617.373 1927.28 619.581L1914.03 595.298Z"
                fill="white"
            />
            <path
                d="M2218.65 1107.43L2207.61 1114.05C2205.4 1114.05 2203.19 1114.05 2203.19 1111.85L2187.74 1083.15C2187.74 1080.94 2187.74 1078.73 2189.95 1078.73C2194.36 1076.53 2196.57 1074.32 2200.99 1072.11C2203.19 1069.9 2205.4 1072.11 2205.4 1074.32L2220.86 1103.02C2220.86 1103.02 2220.86 1105.22 2218.65 1107.43Z"
                fill="black"
            />
            <path
                d="M2192.18 1080.95C2194.39 1078.74 2196.6 1078.74 2198.8 1076.53L2212.05 1100.82L2205.43 1105.23L2192.18 1080.95Z"
                fill="white"
            />
            <path
                d="M1810.38 692.457L1839.08 707.909C1841.29 707.909 1841.29 712.324 1841.29 712.324C1839.08 716.739 1836.87 718.947 1834.66 723.362C1834.66 725.569 1830.25 725.57 1830.25 725.57L1801.55 710.117C1799.34 710.117 1799.34 705.702 1799.34 705.702L1805.97 694.664C1805.97 692.456 1810.38 692.457 1810.38 692.457Z"
                fill="black"
            />
            <path
                d="M1805.85 705.63L1810.27 699.008L1834.55 712.253C1832.34 714.46 1832.34 716.667 1830.13 718.875L1805.85 705.63Z"
                fill="white"
            />
            <path
                d="M2326.91 992.665L2320.29 1003.7C2320.29 1005.91 2315.87 1005.91 2315.87 1005.91L2287.18 990.458C2284.97 990.458 2284.97 986.043 2284.97 986.043C2287.18 981.628 2289.38 979.42 2291.59 975.005C2291.59 972.798 2296.01 972.797 2296.01 972.797L2324.7 988.25C2326.91 988.25 2329.12 990.458 2326.91 992.665Z"
                fill="black"
            />
            <path
                d="M2293.8 983.818C2296 981.61 2296 979.403 2298.21 977.195L2322.49 990.441L2318.08 997.064L2293.8 983.818Z"
                fill="white"
            />
            <path
                d="M1834.66 972.754C1836.87 977.169 1839.08 979.377 1841.29 983.792C1841.29 985.999 1841.29 988.207 1839.08 988.207L1810.38 1003.66C1808.17 1003.66 1805.97 1003.66 1805.97 1001.45L1799.34 990.415C1799.34 988.208 1799.34 986 1801.55 986L1830.25 970.547C1832.46 970.547 1834.66 970.546 1834.66 972.754Z"
                fill="black"
            />
            <path
                d="M1805.85 992.674L1830.13 979.43C1832.34 981.637 1832.34 983.845 1834.55 986.052L1810.27 999.297L1805.85 992.674Z"
                fill="white"
            />
            <path
                d="M2326.81 710.117L2298.12 725.57C2295.91 725.57 2293.7 725.569 2293.7 723.362C2291.49 718.947 2289.29 716.739 2287.08 712.324C2284.87 710.117 2287.08 707.909 2289.29 707.909L2317.98 692.457C2320.19 692.457 2322.4 692.456 2322.4 694.664L2329.02 705.702C2329.02 705.702 2326.81 707.91 2326.81 710.117Z"
                fill="black"
            />
            <path
                d="M2295.94 718.875C2293.73 716.667 2293.73 714.46 2291.52 712.253L2315.81 699.008L2320.22 705.63L2295.94 718.875Z"
                fill="white"
            />
            <path
                d="M2068.5 849.126L2064.08 842.504L1933.84 921.975L1883.06 952.881C1880.86 955.089 1878.65 957.296 1878.65 959.504C1878.65 961.711 1878.65 961.712 1880.86 963.919C1883.06 968.334 1889.69 968.334 1894.1 966.126L2075.12 855.749L2068.5 849.126Z"
                fill="black"
            />
            <path
                d="M2070.67 855.839L1889.65 966.216C1885.23 968.424 1880.82 968.424 1876.4 964.009C1876.4 961.801 1874.2 961.801 1874.2 959.594C1874.2 957.386 1876.4 952.971 1878.61 952.971L1929.38 922.065L2059.63 842.594L2070.67 855.839Z"
                fill="black"
            />
            <path
                opacity="0.2"
                d="M2066.25 846.979L1876.4 961.771C1876.4 959.563 1874.2 959.564 1874.2 957.357C1874.2 955.149 1876.4 950.733 1878.61 950.733L1929.38 919.828L2059.63 840.355L2066.25 846.979Z"
                fill="white"
            />
            <path
                d="M2075.16 789.534V672.534V606.307C2075.16 601.892 2072.95 599.684 2070.75 597.477C2068.54 597.477 2068.54 595.27 2066.33 595.27C2061.92 595.27 2057.5 599.685 2057.5 606.307V842.515H2077.37V789.534H2075.16Z"
                fill="black"
            />
            <path
                d="M2053.02 838.129V601.921C2053.02 597.505 2057.43 593.09 2061.85 590.883C2064.05 590.883 2066.26 590.884 2066.26 593.091C2068.47 595.299 2070.68 597.505 2070.68 601.921V668.147V838.129H2053.02Z"
                fill="black"
            />
            <path
                opacity="0.2"
                d="M2061.83 838.155V593.117C2064.04 593.117 2066.24 593.117 2066.24 595.324C2068.45 597.532 2070.66 599.74 2070.66 604.155V670.381V840.362H2061.83V838.155Z"
                fill="white"
            />
            <path
                d="M2037.62 833.687L2006.71 816.027L2002.3 824.858L2269.41 974.971L2273.83 966.14L2037.62 833.687Z"
                fill="black"
            />
            <path
                d="M2271.64 961.742L2267.22 970.573L2000.11 820.46L2004.52 811.629L2271.64 961.742Z"
                fill="#ED1C24"
            />
            <path
                opacity="0.2"
                d="M2271.62 961.742L2269.41 966.157L2002.3 816.044L2004.5 811.629L2271.62 961.742Z"
                fill="white"
            />
            <path
                d="M2066.35 831.469C2055.31 831.469 2048.69 840.299 2048.69 849.129C2048.69 860.167 2057.52 866.789 2066.35 866.789C2077.39 866.789 2084.01 857.959 2084.01 849.129C2084.01 840.299 2075.18 831.469 2066.35 831.469Z"
                fill="black"
            />
            <path
                d="M2081.81 849.204C2081.81 860.242 2072.98 866.864 2064.15 866.864C2053.11 866.864 2046.48 858.034 2046.48 849.204C2046.48 838.166 2055.31 831.544 2064.15 831.544C2072.98 829.336 2081.81 838.166 2081.81 849.204Z"
                fill="#231F20"
            />
            <path
                d="M2079.59 849.168C2079.59 857.998 2072.97 864.621 2064.14 864.621C2055.31 864.621 2048.69 857.998 2048.69 849.168C2048.69 840.338 2055.31 833.715 2064.14 833.715C2072.97 833.715 2079.59 840.338 2079.59 849.168Z"
                fill="black"
            />
            <path
                d="M2068.61 849.165C2068.61 851.373 2066.4 853.581 2064.2 853.581C2061.99 853.581 2059.78 851.373 2059.78 849.165C2059.78 846.958 2061.99 844.75 2064.2 844.75C2066.4 844.75 2068.61 846.958 2068.61 849.165Z"
                fill="#231F20"
            />
            <path
                d="M2066.33 849.165C2066.33 851.373 2064.12 853.581 2061.92 853.581C2059.71 853.581 2057.5 851.373 2057.5 849.165C2057.5 846.958 2059.71 844.75 2061.92 844.75C2066.33 844.75 2066.33 846.958 2066.33 849.165Z"
                fill="#D5DAE0"
            />
            <path
                d="M2064.19 851.398L2061.98 846.984V851.398H2064.19Z"
                fill="#7D8A92"
            />
            <path
                opacity="0.2"
                d="M2064.14 829.32V866.849C2053.1 866.849 2046.48 858.019 2046.48 849.189C2044.27 838.151 2053.1 829.32 2064.14 829.32Z"
                fill="white"
            />
            <path
                d="M8920.71 5237.76H0V5242.17L5083.99 5270.87L8920.71 5237.76Z"
                fill="#2C272D"
            />
            <path
                d="M121.438 5650.56L6412.95 5734.45"
                stroke="#C5C5DD"
                strokewidth="0.6466"
                strokemiterlimit="10"
            />
            <path
                d="M6805.78 5734.45L7748.4 5747.7"
                stroke="#C5C5DD"
                strokewidth="0.6466"
                strokemiterlimit="10"
            />
            <path
                d="M223 5891.13L6766.18 5966.19"
                stroke="#C5C5DD"
                strokewidth="0.6466"
                strokemiterlimit="10"
            />
            <path
                d="M8741.92 5537.99L121.438 5485.01"
                stroke="#C5C5DD"
                strokewidth="0.6675"
                strokemiterlimit="10"
            />
            <path
                d="M6185.55 5871.27L5684.44 5875.69L5183.33 5880.1L4181.1 5884.52L3178.87 5886.73H2677.76L2174.44 5884.52L2677.76 5880.1L3178.87 5875.69L4181.1 5871.27L5183.33 5869.07H5684.44H6185.55V5871.27Z"
                fill="#C5C5DD"
            />
            <path
                d="M8891.96 5738.81C8693.28 5765.3 8492.39 5776.34 8293.71 5782.96C8095.03 5789.59 7894.15 5787.38 7695.47 5780.76C7596.13 5778.55 7496.79 5771.93 7395.24 5767.51L7245.13 5756.47C7194.35 5752.06 7145.79 5749.85 7095.01 5743.23C6896.33 5723.36 6695.45 5699.08 6496.77 5657.13C6490.15 5654.93 6487.94 5650.51 6487.94 5643.89C6487.94 5639.47 6492.35 5637.27 6496.77 5635.06C6695.45 5582.08 6896.33 5553.38 7095.01 5533.51C7293.69 5513.64 7494.58 5504.81 7693.26 5504.81C7891.94 5504.81 8092.83 5511.44 8291.51 5526.89C8490.19 5544.55 8691.07 5568.83 8889.75 5615.19L8896.37 5617.4C8929.49 5626.23 8949.36 5659.34 8942.73 5692.45C8938.32 5716.74 8916.24 5734.4 8891.96 5738.81Z"
                fill="white"
            />
            <path
                d="M7024.36 6036.87C6900.74 6039.08 6779.32 6041.28 6655.7 6041.28L6287.04 6043.49H5918.38H5732.94L5547.51 6041.28V6039.08L5732.94 6034.66L5918.38 6032.46L6287.04 6030.25H6655.7H6841.13L7026.57 6032.46L7024.36 6036.87Z"
                fill="#C5C5DD"
            />
            <path
                d="M8653.48 5535.76C8653.48 5549.01 4732.88 5681.46 3030.85 5593.16C1273.64 5502.65 1342.08 5498.23 1152.23 5462.91C1123.53 5458.5 4346.55 5489.4 6050.78 5484.99C6825.63 5482.78 8653.48 5520.31 8653.48 5535.76Z"
                fill="#444247"
            />
            <path
                d="M2978.01 5575.46C2978.01 5544.56 4344.48 5546.77 5167.9 5542.35C5991.31 5540.14 6042.09 5537.94 6042.09 5568.84C6042.09 5599.75 4532.12 5641.69 3708.71 5646.11C2885.29 5648.31 2978.01 5606.37 2978.01 5575.46Z"
                fill="#2C272D"
            />
            <path
                d="M280.407 5257.65H1421.71C1452.62 5257.65 1479.11 5233.37 1479.11 5200.25H225.219C223.011 5233.37 249.502 5257.65 280.407 5257.65Z"
                fill="#212056"
            />
            <path
                d="M569.483 4922.12C569.483 4922.12 631.295 4919.92 686.483 4858.1C743.88 4794.08 876.332 4760.97 986.71 4767.59C1097.09 4774.22 1205.26 4851.48 1242.79 4937.57C1280.31 5025.88 1280.31 5125.22 1280.31 5125.22L384.049 5129.63C373.011 5129.63 359.766 5118.6 359.766 5116.39C359.766 5100.94 366.388 5078.86 395.087 5081.07C448.068 5083.27 569.483 4922.12 569.483 4922.12Z"
                fill="var(--yellow-500)"
            />
            <path
                d="M1094.79 4944.19C1094.79 4944.19 1015.32 4842.64 940.265 4849.26C865.208 4855.88 854.17 4990.54 902.736 5039.11C949.095 5085.47 955.717 5076.64 955.717 5076.64C955.717 5076.64 880.66 5076.64 856.377 5087.68C832.094 5098.71 840.925 5123 840.925 5123H1198.55C1198.55 5123 1165.43 5023.66 1094.79 4944.19Z"
                fill="#E94E1B"
            />
            <path
                d="M585.012 5032.47L635.785 4994.95C635.785 4994.95 673.313 5001.57 724.087 5032.47C774.861 5061.17 779.276 5072.21 783.691 5094.29C788.106 5116.36 783.691 5120.77 783.691 5120.77H702.012L585.012 5032.47Z"
                fill="#E94E1B"
            />
            <path
                d="M1121.27 4944.23C1121.27 4944.23 1017.51 4840.48 942.456 4847.1C867.4 4853.72 885.06 5010.46 938.042 5047.99C991.023 5087.72 1006.48 5083.31 1006.48 5083.31C1006.48 5083.31 907.136 5076.69 882.853 5089.93C858.57 5100.97 865.192 5123.04 865.192 5123.04H1222.82C1225.02 5123.04 1191.91 5023.71 1121.27 4944.23Z"
                fill="var(--yellow-400)"
            />
            <path
                d="M840.954 5145.03L818.879 5125.16C863.03 5061.14 909.388 5043.48 995.483 5043.48C1081.58 5043.48 1147.8 5054.52 1218.44 5028.03C1205.2 5076.6 980.03 5072.18 966.784 5074.39C955.747 5076.6 840.954 5145.03 840.954 5145.03Z"
                fill="#E94E1B"
            />
            <path
                d="M280.407 5257.65H1421.71C1452.62 5257.65 1479.11 5233.37 1479.11 5200.25H225.219C223.011 5233.37 249.502 5257.65 280.407 5257.65Z"
                fill="#444247"
            />
            <path
                d="M381.87 5215.73C258.247 5215.73 324.473 5217.93 225.133 5222.35C222.926 5215.73 220.719 5209.1 220.719 5202.48H1474.61C1474.61 5213.52 1470.19 5224.56 1463.57 5235.59C1346.57 5222.35 593.794 5215.73 381.87 5215.73Z"
                fill="black"
            />
            <path
                d="M170.043 5202.44H1529.89C1547.55 5202.44 1563.01 5186.98 1563.01 5169.32V5160.5C1563.01 5142.84 1547.55 5127.38 1529.89 5127.38H170.043C152.383 5127.38 136.93 5142.84 136.93 5160.5V5169.32C136.93 5186.98 150.175 5202.44 170.043 5202.44Z"
                fill="#2C272D"
            />
            <path
                d="M165.628 5125.24H1534.31C1549.76 5125.24 1563.01 5138.48 1563.01 5153.94V5171.6C1563.01 5173.81 1563.01 5176.01 1563.01 5178.22C1560.8 5164.97 1547.55 5156.14 1534.31 5156.14H165.628C152.383 5156.14 141.345 5164.97 136.93 5178.22C136.93 5176.01 136.93 5173.81 136.93 5171.6V5153.94C136.93 5138.48 150.175 5125.24 165.628 5125.24Z"
                fill="#444247"
            />
            <path
                d="M657.85 5006.02C657.85 5006.02 730.699 5045.76 757.19 5065.63C783.68 5085.49 768.227 5125.23 768.227 5125.23H474.624C465.793 5125.23 353.208 5162.76 353.208 5156.14C353.208 5140.68 351.001 5076.66 403.982 5081.08C487.869 5087.7 545.265 5056.8 543.058 5039.14C540.85 5019.27 611.491 4975.12 657.85 5006.02Z"
                fill="var(--yellow-400)"
            />
            <path
                d="M421.676 5072.23C481.28 5041.32 571.789 4922.12 571.789 4922.12C571.789 4922.12 589.449 4922.12 611.525 4913.29C613.732 4944.19 607.11 4997.17 565.167 5070.02C565.167 5067.81 481.28 5085.48 421.676 5072.23Z"
                fill="#E94E1B"
            />
            <path
                d="M468.02 4769.79C468.02 4769.79 527.624 4807.32 525.416 4840.43C525.416 4840.43 580.605 4866.92 585.021 4877.96C589.436 4888.99 611.511 4953.01 547.492 5063.39C547.492 5063.39 417.246 5094.3 370.888 5043.52L346.605 4977.3C346.605 4977.3 298.039 4926.52 298.039 4891.2L377.511 4906.65C377.511 4906.65 434.907 4851.47 456.982 4851.47L468.02 4769.79Z"
                fill="var(--yellow-500)"
            />
            <path
                d="M1264.93 5006.06C1264.93 5006.06 1269.35 5050.21 1225.2 5085.53C1181.05 5120.85 1061.84 5114.23 993.404 5118.65C924.97 5123.06 889.649 5142.93 878.611 5195.91C867.574 5248.89 750.574 5237.85 796.932 5158.38C843.291 5078.91 896.272 5045.79 1011.06 5048C1125.86 5052.42 1227.4 5045.8 1231.82 5006.06C1236.23 4959.7 1264.93 5006.06 1264.93 5006.06Z"
                fill="var(--yellow-400)"
            />
            <path
                d="M3331.07 816.123C3331.07 816.123 3589.35 734.442 3726.22 820.537C3726.22 820.537 3752.71 851.445 3746.09 888.973C3739.47 928.709 3514.3 1008.18 3514.3 1008.18C3514.3 1008.18 3342.11 933.123 3331.07 893.387C3320.03 853.651 3331.07 816.123 3331.07 816.123Z"
                fill="url(#paint0_linear_2599_872)"
            />
            <path
                d="M3366.43 683.664L3359.8 831.569L3328.9 873.513L3419.41 1147.25L3679.9 1264.25L3816.77 1034.66L3759.37 884.551C3759.37 884.551 3715.22 869.099 3688.73 833.779V685.871H3366.43V683.664Z"
                fill="url(#paint1_linear_2599_872)"
            />
            <path
                d="M3529.86 683.664H3366.5L3359.88 831.569L3331.18 875.72L3421.69 1145.04L3554.14 1204.65L3529.86 683.664Z"
                fill="url(#paint2_linear_2599_872)"
            />
            <path
                d="M3366.54 692.474C3366.54 692.474 3503.41 816.096 3534.31 816.096C3582.88 816.096 3686.63 734.417 3686.63 734.417V654.945L3366.54 692.474Z"
                fill="#C65C6D"
            />
            <path
                d="M3309.06 438.571L3331.14 577.646C3331.14 577.646 3324.52 588.684 3317.89 588.684C3300.23 588.684 3256.08 529.08 3256.08 460.646C3253.87 392.212 3286.99 398.835 3309.06 438.571Z"
                fill="url(#paint3_linear_2599_872)"
            />
            <path
                d="M3781.42 465.102C3779.21 531.328 3732.85 590.932 3715.19 590.932H3712.98C3719.61 542.366 3726.23 493.8 3728.44 469.517C3728.44 465.102 3728.44 460.687 3728.44 458.479V438.612C3752.72 403.291 3783.63 398.875 3781.42 465.102Z"
                fill="url(#paint4_linear_2599_872)"
            />
            <path
                fillrule="evenodd"
                cliprule="evenodd"
                d="M3739.48 385.599V403.259V429.75C3739.48 431.957 3739.48 436.372 3739.48 440.787C3735.07 491.561 3710.79 665.958 3704.16 681.411C3701.96 688.034 3591.58 765.298 3558.47 791.788C3551.84 796.204 3527.56 798.411 3520.94 793.995C3481.2 771.92 3379.65 705.693 3355.37 679.203C3350.96 672.58 3346.54 665.957 3346.54 657.127C3344.33 637.259 3335.5 593.108 3328.88 551.165C3328.88 548.957 3328.88 548.957 3328.88 546.75C3324.47 515.844 3320.05 484.938 3315.63 469.485C3313.43 462.863 3313.43 458.448 3313.43 458.448L3309.01 409.881C3309.01 401.051 3306.8 390.014 3306.8 381.183C3306.8 244.315 3370.82 129.523 3523.14 129.523C3673.26 129.523 3739.48 246.523 3739.48 381.183C3739.48 383.391 3739.48 383.391 3739.48 385.599Z"
                fill="url(#paint5_linear_2599_872)"
            />
            <path
                fillrule="evenodd"
                cliprule="evenodd"
                d="M3739.56 385.588C3739.56 423.117 3737.35 429.739 3737.35 440.777H3739.56C3735.14 491.551 3710.86 665.948 3704.24 681.4C3702.03 690.231 3591.65 767.495 3589.45 769.702L3679.95 676.985C3686.58 646.079 3702.03 548.947 3710.86 482.721C3717.48 440.778 3713.07 396.625 3699.82 354.682C3690.99 325.984 3686.58 279.625 3684.37 277.418C3635.8 246.512 3381.94 228.852 3333.37 253.135C3326.75 275.211 3324.54 312.739 3315.71 376.758C3309.09 431.946 3328.95 548.946 3328.95 553.361C3328.95 551.154 3328.95 551.155 3328.95 548.947C3328.95 548.947 3322.33 511.419 3315.71 460.645L3311.29 412.079C3311.29 403.249 3309.09 392.211 3309.09 383.381C3309.09 246.513 3373.1 131.72 3525.43 131.72C3666.71 129.512 3741.77 239.89 3739.56 385.588Z"
                fill="url(#paint6_linear_2599_872)"
            />
            <path
                d="M3313.42 476.097L3282.52 257.55L3317.84 208.984L3286.93 226.644C3286.93 226.644 3397.31 69.909 3476.78 63.2864C3556.25 56.6637 3721.82 184.701 3763.76 248.72L3728.44 513.626C3728.44 513.626 3732.86 359.098 3724.03 334.815C3724.03 334.815 3690.91 235.475 3684.29 235.475C3684.29 235.475 3408.35 343.645 3348.74 261.966C3322.25 222.23 3313.42 476.097 3313.42 476.097Z"
                fill="#1A1A1A"
            />
            <path
                d="M3671.01 45.6449C3671.01 45.6449 3726.19 36.8153 3739.44 43.4379C3752.68 50.0606 3814.5 114.079 3765.93 248.74C3765.93 248.74 3697.5 211.212 3425.97 239.91C3425.97 239.91 3359.74 250.948 3388.44 142.778C3388.44 142.778 3474.53 103.042 3489.99 76.5512C3505.44 50.0606 3379.61 92.0043 3379.61 92.0043C3379.61 92.0043 3498.82 21.3619 3629.06 12.5317C3629.06 12.5317 3629.06 8.11659 3606.99 1.49394C3602.57 -0.713605 3673.21 -7.33626 3671.01 45.6449Z"
                fill="#1A1A1A"
            />
            <path
                d="M3512.17 50.0977C3512.17 50.0977 3521 85.4184 3514.37 105.286C3507.75 125.154 3437.11 160.475 3417.24 160.475C3417.24 160.475 3461.39 171.513 3521 122.947C3534.24 114.116 3529.83 74.3807 3512.17 50.0977Z"
                fill="#474747"
            />
            <path
                d="M3538.69 52.2617C3538.69 52.2617 3551.94 111.865 3540.9 138.355C3529.86 164.846 3415.07 195.752 3388.58 195.752C3388.58 195.752 3454.8 215.62 3549.73 160.431C3560.77 153.808 3562.97 85.375 3538.69 52.2617Z"
                fill="white"
            />
            <path
                d="M3955.76 2659.43C3946.93 2376.86 3935.89 2228.95 3935.89 2228.95C3935.89 2228.95 3573.85 2246.61 3454.64 2339.33C3308.95 2226.75 3116.89 2270.9 3116.89 2270.9C3116.89 2270.9 3037.42 2485.03 3024.17 2774.22C3010.93 3061.2 3048.45 3588.8 3063.91 3807.35C3079.36 4025.9 3079.36 4911.13 3079.36 4911.13C3163.25 4966.31 3313.36 4930.99 3313.36 4930.99C3313.36 4930.99 3359.72 3990.58 3381.79 3889.03C3403.87 3785.27 3425.95 3560.11 3430.36 3398.95C3434.78 3173.78 3470.1 3100.94 3503.21 2968.48C3529.7 3092.11 3547.36 3151.71 3547.36 3348.18C3547.36 3504.92 3565.02 3727.88 3584.89 3829.43C3604.76 3930.97 3631.25 4933.2 3631.25 4933.2C3631.25 4933.2 3776.95 4970.73 3860.83 4919.96C3860.83 4919.96 3878.49 3972.92 3898.36 3758.79C3920.44 3544.65 3964.59 2941.99 3955.76 2659.43Z"
                fill="var(--surface-500)"
            />
            <path
                d="M3048.55 2509.29L3041.93 2584.35C3041.93 2584.35 3116.99 2654.99 3437.08 2661.61C3474.61 2661.61 3512.14 2661.61 3549.67 2657.2C3593.82 2652.78 3666.67 2650.57 3732.89 2659.4C3836.65 2672.65 3940.4 2654.99 3966.89 2604.21V2531.36L3048.55 2509.29Z"
                fill="#E94E1B"
            />
            <path
                d="M4125.91 1092.05C4125.91 1092.05 4145.78 1094.26 4176.69 1145.03C4218.63 1211.26 4269.4 1727.83 4269.4 1908.84C4271.61 2089.86 4247.33 2127.39 4212.01 2175.96C4176.69 2224.52 3986.84 2392.3 3843.35 2407.75C3843.35 2407.75 3821.27 2427.62 3825.69 2383.47C3830.1 2339.32 3814.65 2350.35 3854.38 2259.84C3880.87 2202.45 3913.99 2076.62 4006.7 1988.32C4006.7 1988.32 4002.29 1875.73 3966.97 1648.35C3940.48 1467.33 4070.72 1195.81 4125.91 1092.05Z"
                fill="var(--yellow-400)"
            />
            <path
                d="M2905.09 1120.71C2905.09 1120.71 2874.18 1058.9 2847.69 1116.29C2821.2 1173.69 2690.96 1765.31 2675.5 1946.33C2662.26 2129.56 2686.54 2167.09 2724.07 2215.65C2761.6 2264.22 2977.94 2427.58 3145.71 2440.82C3145.71 2440.82 3172.2 2460.69 3170 2414.33C3167.79 2367.97 3185.45 2379.01 3143.5 2288.5C3117.01 2231.1 3070.66 2142.8 2953.66 2016.97C2953.66 2016.97 2964.69 1875.69 3022.09 1646.1C3070.66 1469.5 2964.69 1224.46 2905.09 1120.71Z"
                fill="var(--yellow-400)"
            />
            <path
                d="M3351.05 937.495C3331.18 906.589 3293.65 895.552 3262.74 911.005C3165.61 955.156 2982.38 1034.63 2936.03 1052.29C2898.5 1065.53 2799.16 1103.06 2860.97 1160.46C2909.54 1204.61 2944.86 1266.42 2958.1 1332.65C2986.8 1469.51 2953.69 1509.25 2997.84 1785.19C3008.87 1849.21 2997.84 2328.25 3037.57 2491.61C3044.2 2518.1 3064.06 2540.18 3088.35 2546.8C3163.4 2568.87 3333.38 2615.23 3472.46 2604.19C3496.74 2601.99 3604.91 2597.57 3620.37 2599.78C3697.63 2601.99 3812.42 2628.48 3925.01 2577.7C3949.29 2566.67 3971.37 2535.76 3977.99 2509.27C4015.52 2341.5 3977.99 2116.33 3971.37 2014.78C3962.54 1906.61 3966.95 1789.61 4002.27 1529.12C4030.97 1319.4 4108.23 1235.51 4154.59 1164.87C4178.88 1127.35 4167.84 1098.64 4132.52 1074.36C4037.59 1010.34 3874.23 968.399 3788.14 930.871C3761.65 919.833 3728.54 926.456 3708.67 950.739C3677.76 986.06 3626.99 1036.83 3569.59 1069.95C3549.72 1080.99 3525.44 1083.19 3503.37 1072.15C3419.48 1025.8 3375.33 975.023 3351.05 937.495Z"
                fill="var(--yellow-500)"
            />
            <path
                d="M3289.23 906.618C3289.23 906.618 3304.69 822.732 3331.18 816.109C3331.18 816.109 3320.14 904.412 3509.99 977.262L3532.06 1109.71C3532.06 1109.71 3320.14 1063.35 3289.23 906.618Z"
                fill="#E94E1B"
            />
            <path
                d="M3509.88 975.009C3509.88 975.009 3688.69 926.444 3721.8 860.217C3730.63 833.727 3726.22 818.273 3726.22 818.273C3726.22 818.273 3785.82 849.179 3770.37 928.651C3757.12 994.877 3569.48 1114.09 3531.95 1109.67C3494.43 1103.05 3509.88 975.009 3509.88 975.009Z"
                fill="#E94E1B"
            />
            <path
                d="M3479 2824.99C3479 2824.99 3306.81 2725.65 3269.28 2699.16C3231.76 2672.67 3275.91 2725.65 3326.68 2760.97C3377.45 2794.09 3536.4 2864.73 3479 2824.99Z"
                fill="#1C2226"
            />
            <path
                d="M3445.97 2844.84C3445.97 2844.84 3309.1 2791.86 3278.2 2778.61C3247.29 2765.37 3284.82 2791.86 3326.76 2811.73C3370.92 2829.39 3494.54 2864.71 3445.97 2844.84Z"
                fill="#1C2226"
            />
            <path
                d="M3746.18 2736.66C3746.18 2736.66 3580.61 2809.51 3543.08 2822.75C3505.55 2836 3560.74 2829.37 3611.52 2809.51C3664.5 2789.64 3805.78 2714.58 3746.18 2736.66Z"
                fill="#1C2226"
            />
            <path
                d="M3050.73 2842.62C3099.29 2807.3 3194.22 2674.85 3172.14 2652.77C3161.1 2659.4 3143.44 2696.93 3116.95 2736.66C3068.39 2811.72 3010.99 2873.53 3050.73 2842.62Z"
                fill="#1C2226"
            />
            <path
                d="M3920.54 2886.74C3876.39 2847 3794.71 2703.51 3819 2683.64C3830.04 2690.26 3843.28 2732.21 3865.36 2771.94C3907.3 2853.62 3958.07 2919.85 3920.54 2886.74Z"
                fill="#1C2226"
            />
            <path
                d="M3121.41 4891.25C3165.56 4873.59 3282.56 4842.69 3309.05 4986.18C3309.05 4986.18 3326.72 5129.67 3309.05 5189.27C3291.39 5251.09 3057.39 5231.22 3052.98 5184.86C3039.73 5014.88 3077.26 4981.77 3097.13 4919.95C3101.54 4904.5 3110.38 4895.67 3121.41 4891.25Z"
                fill="#111111"
            />
            <path
                d="M3200.88 5191.46C3200.88 5182.63 3256.07 4961.88 3256.07 4957.46C3256.07 4955.25 3267.11 4933.18 3278.15 4911.1C3234 4855.91 3156.73 4877.99 3121.41 4891.24C3110.38 4895.65 3101.54 4906.69 3097.13 4919.93C3077.26 4981.75 3039.73 5014.86 3052.98 5184.84C3055.19 5213.54 3139.07 5231.2 3209.71 5228.99C3205.3 5209.12 3200.88 5195.88 3200.88 5191.46Z"
                fill="url(#paint7_linear_2599_872)"
            />
            <path
                d="M3309.13 4983.96C3302.51 4946.43 3289.27 4919.94 3271.61 4904.49C3258.36 4948.64 3242.91 4997.21 3245.12 5001.62C3249.53 5010.45 3236.29 5200.3 3234.08 5226.79C3271.61 5222.38 3300.3 5211.34 3306.93 5191.47C3326.79 5127.45 3309.13 4983.96 3309.13 4983.96Z"
                fill="url(#paint8_linear_2599_872)"
            />
            <path
                d="M3050.76 5103.16C3050.76 5125.23 3050.76 5151.72 3052.97 5182.63C3057.38 5228.99 3289.17 5248.86 3309.04 5187.04C3313.46 5169.38 3315.66 5147.31 3317.87 5120.82C3174.38 5131.86 3094.91 5118.61 3050.76 5103.16Z"
                fill="url(#paint9_linear_2599_872)"
            />
            <path
                d="M3671.07 4897.81C3717.42 4880.15 3838.84 4849.25 3865.33 4992.74C3865.33 4992.74 3885.2 5136.23 3865.33 5195.83C3845.46 5257.65 3604.84 5237.78 3600.42 5191.42C3584.97 5021.44 3624.71 4988.32 3646.78 4926.51C3651.2 4913.27 3660.03 4902.23 3671.07 4897.81Z"
                fill="#111111"
            />
            <path
                d="M3752.74 5200.27C3752.74 5191.44 3810.14 4970.69 3810.14 4966.27C3810.14 4964.06 3821.17 4941.99 3832.21 4919.91C3785.85 4864.72 3706.38 4886.8 3671.06 4900.04C3660.02 4904.46 3648.98 4915.5 3644.57 4928.74C3624.7 4990.55 3584.97 5023.67 3598.21 5193.65C3600.42 5222.35 3688.72 5240.01 3761.57 5237.8C3757.15 5217.93 3752.74 5202.48 3752.74 5200.27Z"
                fill="url(#paint10_linear_2599_872)"
            />
            <path
                d="M3865.29 4992.77C3858.67 4955.24 3845.42 4928.75 3827.76 4913.3C3814.52 4957.45 3799.06 5006.01 3801.27 5010.43C3805.69 5019.26 3792.44 5209.11 3790.23 5235.6C3827.76 5231.18 3858.67 5220.15 3865.29 5200.28C3882.95 5136.26 3865.29 4992.77 3865.29 4992.77Z"
                fill="url(#paint11_linear_2599_872)"
            />
            <path
                d="M3598.16 5111.96C3598.16 5134.04 3598.16 5160.53 3600.36 5191.44C3604.78 5237.79 3845.4 5257.66 3865.27 5195.85C3869.69 5178.19 3871.89 5156.12 3874.1 5129.63C3723.99 5140.66 3642.31 5127.42 3598.16 5111.96Z"
                fill="url(#paint12_linear_2599_872)"
            />
            <path
                d="M6158.95 5169.34C6158.95 5160.51 5176.6 5162.72 4584.97 5162.72C3993.35 5162.72 3955.82 5162.72 3955.82 5171.55C3955.82 5180.38 5041.93 5191.41 5633.56 5191.41C6225.18 5191.41 6158.95 5178.17 6158.95 5169.34Z"
                fill="#444247"
            />
            <path
                d="M4706.56 5111.94C4728.64 5019.22 4768.37 4010.37 4805.9 3831.56L4933.94 3833.77C4889.79 3975.05 4746.3 5138.43 4735.26 5171.55C4730.84 5182.58 4717.6 5198.04 4710.98 5195.83C4691.11 5193.62 4695.52 5175.96 4697.73 5162.72C4699.94 5145.06 4704.35 5129.6 4706.56 5111.94Z"
                fill="#D19582"
            />
            <path
                d="M5236.38 3818.35L5371.04 3805.11C5368.83 3822.77 5364.42 3844.84 5364.42 3862.51C5351.17 3990.54 5276.12 5045.75 5267.29 5147.3C5265.08 5162.75 5273.91 5189.24 5245.21 5187.04C5220.93 5184.83 5227.55 5160.54 5227.55 5145.09C5227.55 5034.71 5238.59 3937.56 5236.38 3818.35Z"
                fill="#D19582"
            />
            <path
                d="M4150.21 5160.52C4174.5 5043.52 4291.5 3820.54 4304.74 3760.94L4441.61 3794.05C4408.5 3906.64 4236.31 5003.79 4185.54 5169.35C4181.12 5184.81 4178.91 5206.88 4159.04 5202.47C4136.97 5195.84 4145.8 5175.98 4150.21 5160.52Z"
                fill="#D19582"
            />
            <path
                d="M5781.53 3738.87C5796.98 3833.8 5951.51 5039.12 5969.17 5149.5C5971.38 5164.95 5964.75 5195.85 5960.34 5195.85C5936.06 5195.85 5929.43 5175.98 5925.02 5158.32C5905.15 5085.47 5706.47 3983.91 5673.36 3858.08C5666.73 3829.38 5655.7 3794.06 5646.87 3765.36L5781.53 3738.87Z"
                fill="#D19582"
            />
            <path
                d="M5598.35 2374.64C5598.35 2407.75 5598.34 2440.87 5596.14 2473.98C5578.48 2747.71 5551.99 3317.26 5510.04 3586.58C5507.84 3606.45 5507.84 3619.7 5516.67 3626.32L5476.93 3632.94C5483.55 3624.11 5487.97 3610.87 5487.97 3586.58C5499.01 3306.23 5507.84 2734.47 5543.16 2460.73C5547.57 2427.62 5547.57 2315.04 5516.67 2312.83C5487.97 2310.62 5406.29 2292.96 5377.59 2292.96C5348.89 2292.96 5340.06 2306.21 5340.06 2339.32C5346.68 2659.41 5320.19 3259.87 5291.5 3573.34C5289.29 3595.41 5291.5 3608.66 5298.12 3615.28L5256.18 3621.9C5265.01 3608.66 5265 3586.58 5265 3544.64C5269.42 3348.17 5273.84 2855.89 5282.67 2657.21C5287.08 2549.04 5287.08 2451.9 5298.12 2343.73C5300.33 2306.2 5245.14 2297.37 5214.23 2297.37C5194.36 2297.37 5185.53 2290.75 5165.66 2292.96C5097.23 2299.58 5099.44 2299.58 5101.65 2381.26C5108.27 2657.21 5112.68 3226.75 5117.1 3500.49C5117.1 3535.81 5114.89 3571.13 5114.89 3606.45C5114.89 3619.7 5117.1 3628.53 5123.72 3635.15L5077.36 3641.77C5083.99 3630.73 5083.99 3613.07 5081.78 3577.75C5064.12 3268.7 5037.63 2674.87 5046.46 2368.02C5046.46 2359.19 5046.46 2350.36 5046.46 2341.53C5044.25 2326.07 5039.84 2315.03 5024.38 2319.45C5004.51 2323.86 5008.93 2319.45 4989.06 2323.87L4975.82 2328.28C4960.36 2330.49 4891.93 2330.49 4878.68 2332.69C4841.16 2341.52 4838.95 2345.94 4845.57 2392.3C4856.61 2476.19 4869.85 2560.07 4874.27 2643.96C4889.72 2869.13 4902.97 3390.11 4916.21 3615.28C4918.42 3639.57 4920.63 3650.6 4927.25 3657.22L4883.1 3663.85C4889.72 3652.81 4889.72 3637.36 4885.31 3606.45C4867.65 3451.92 4849.99 3297.4 4838.95 3142.87C4827.91 2994.96 4790.38 2544.62 4785.97 2396.71C4783.76 2350.36 4779.34 2343.73 4741.82 2352.56C4673.38 2356.98 4688.83 2352.56 4662.34 2350.36C4638.06 2348.15 4576.25 2350.36 4582.87 2379.06C4613.78 2562.28 4644.68 2988.34 4673.38 3171.56C4691.04 3286.36 4706.5 3401.15 4719.74 3518.15C4721.95 3540.23 4724.16 3551.26 4730.78 3555.68L4655.72 3566.72C4662.34 3557.89 4660.14 3546.85 4657.93 3524.77C4624.82 3308.43 4591.7 2796.28 4563 2579.94C4551.97 2500.47 4507.82 2368.02 4474.7 2350.36C4437.17 2328.28 4384.19 2321.66 4364.32 2279.72C4342.25 2233.36 4324.59 2184.79 4304.72 2136.22C4295.89 2116.36 4302.51 2103.11 4317.97 2094.28C4417.31 2034.68 4947.12 1844.83 5805.85 2052.34C5834.55 2058.96 5838.97 2072.21 5827.93 2103.11C5812.48 2149.47 5797.03 2198.03 5779.36 2244.39C5774.95 2257.64 5770.53 2268.68 5761.7 2279.72C5733.01 2323.87 5695.48 2334.9 5649.12 2326.07C5607.18 2319.45 5600.55 2326.07 5598.35 2374.64Z"
                fill="black"
            />
            <path
                d="M4176.62 3553.45C4183.24 3529.17 4200.9 3524.75 4220.77 3524.75C4264.92 3524.75 4309.07 3531.37 4351.01 3526.96C4938.22 3451.9 5770.47 3544.62 5880.84 3546.83C5894.09 3546.83 5907.33 3546.83 5918.37 3551.24C5942.66 3560.07 5947.07 3588.77 5929.41 3606.43C5920.58 3613.05 5911.75 3619.67 5900.71 3621.88C5867.6 3632.92 5834.49 3643.96 5801.37 3655C5792.54 3659.41 5781.5 3670.45 5781.5 3677.07C5781.5 3705.77 5783.71 3732.26 5788.13 3760.96C5788.13 3763.17 5788.13 3763.17 5788.13 3765.37L5653.47 3789.66C5646.84 3769.79 5640.22 3749.92 5635.81 3727.85C5629.18 3707.98 5620.35 3699.15 5598.28 3703.56C5538.67 3712.39 5476.86 3721.22 5415.05 3727.85C5390.77 3730.05 5384.15 3741.09 5381.94 3760.96C5379.73 3785.24 5375.32 3809.52 5370.9 3833.81L5236.24 3847.05C5236.24 3829.39 5236.24 3813.94 5234.03 3796.28C5231.82 3730.05 4973.54 3732.26 4947.05 3794.07C4942.64 3802.9 4940.43 3811.73 4936.01 3820.56C4933.81 3829.39 4929.39 3838.22 4927.18 3847.05L4810.18 3844.84H4799.14C4801.35 3836.01 4803.56 3827.19 4803.56 3818.35C4807.98 3791.86 4810.18 3763.17 4812.39 3734.47C4792.52 3732.26 4465.8 3690.32 4456.97 3716.81C4450.35 3741.09 4445.94 3763.17 4437.11 3787.45C4437.11 3789.66 4434.9 3791.86 4434.9 3794.07L4298.03 3758.75C4302.45 3732.26 4309.07 3705.77 4313.48 3677.07C4320.11 3639.54 4311.28 3630.71 4273.75 3621.88C4247.26 3615.26 4222.97 3606.43 4198.69 3595.39C4183.24 3593.19 4169.99 3577.73 4176.62 3553.45Z"
                fill="black"
            />
            <path
                d="M5602.78 2500.42L5607.2 2880.11L5496.82 2952.96C5496.82 2952.96 5547.59 3021.4 5604.99 3012.57C5662.39 3003.74 5788.22 2926.47 5788.22 2919.85C5790.42 2897.77 5858.86 2451.85 5858.86 2451.85L5602.78 2500.42Z"
                fill="url(#paint13_linear_2599_872)"
            />
            <path
                d="M4774.92 1668.17C4777.13 1668.17 5033.2 1787.38 5209.81 1674.79C5209.81 1674.79 5247.34 1683.62 5256.17 1732.19C5256.17 1732.19 5543.15 1838.15 5655.73 1911C5768.32 1983.85 5825.72 2200.19 5847.79 2392.25C5847.79 2392.25 5739.62 2189.15 5622.62 2303.94C5622.62 2303.94 5501.21 2381.21 5510.04 2555.6C5518.87 2730 5507.83 3204.62 5507.83 3204.62C5507.83 3204.62 5395.24 3127.36 5271.62 3158.26C5148 3189.17 4905.17 3175.92 4880.88 3160.47C4858.81 3145.02 4684.41 3109.7 4585.07 3171.51C4485.73 3233.32 4468.07 3149.43 4468.07 3149.43L4543.13 2266.41C4543.13 2266.41 4479.11 2253.17 4457.03 2239.92C4419.51 2217.85 4249.53 2228.89 4218.62 2429.77C4218.62 2429.77 4154.6 2008.13 4366.53 1904.38C4580.66 1802.83 4774.92 1668.17 4774.92 1668.17Z"
                fill="var(--primary-color)"
            />
            <path
                d="M4501.17 2496.03L4554.15 2851.44L4757.24 2957.41C4757.24 2957.41 4706.47 3025.84 4649.07 3017.01C4591.67 3008.18 4337.81 2922.09 4337.81 2900.01C4337.81 2877.94 4247.3 2447.46 4247.3 2447.46L4501.17 2496.03Z"
                fill="url(#paint14_linear_2599_872)"
            />
            <path
                d="M4649.09 3480.55L4790.38 3544.57L4973.6 3513.67C4997.89 3509.25 5019.96 3509.25 5044.24 3513.67L5624.83 3573.27L5430.57 3423.16L5106.06 3361.35H4900.75L4649.09 3480.55Z"
                fill="url(#paint15_linear_2599_872)"
            />
            <path
                d="M5198.7 1730.02C5198.7 1725.61 5207.54 1672.63 5207.54 1672.63C5207.54 1672.63 5178.84 1666 5150.14 1677.04C5121.44 1688.08 4830.04 1659.38 4830.04 1659.38C4830.04 1659.38 4805.76 1657.17 4774.86 1666C4757.2 1672.62 4913.93 1725.6 4918.35 1725.6C4922.76 1725.6 5070.67 1745.47 5083.91 1743.27C5094.95 1743.27 5198.7 1730.02 5198.7 1730.02Z"
                fill="#2B4ECC"
            />
            <path
                d="M4684.36 4765.43C4684.36 4765.43 4785.91 4145.11 4788.11 3544.65L5033.15 3407.79L4677.74 3233.39L4485.68 3332.73C4485.68 3332.73 4331.15 3398.96 4333.36 3666.07C4335.57 3933.18 4443.74 4758.81 4443.74 4758.81C4443.74 4758.81 4622.55 4805.17 4684.36 4765.43Z"
                fill="url(#paint16_linear_2599_872)"
            />
            <path
                d="M5494.54 3032.47C5503.37 3032.47 5867.62 3127.39 5863.2 3213.49C5858.79 3299.58 5858.79 3615.26 5582.84 3566.7C5304.69 3518.13 4931.62 3421 4931.62 3421C4931.62 3421 5006.67 2994.94 5494.54 3032.47Z"
                fill="#1D3C91"
            />
            <path
                d="M4474.75 4732.27L4450.47 4862.51L4638.11 4882.38V4769.79L4474.75 4732.27Z"
                fill="url(#paint17_linear_2599_872)"
            />
            <path
                d="M4457.04 4831.59C4512.23 4813.93 4655.72 4783.02 4688.83 4926.51C4688.83 4926.51 4710.91 5070.01 4688.83 5129.61C4666.76 5191.42 4377.57 5171.55 4373.15 5125.19C4355.49 4955.21 4401.85 4922.1 4428.34 4860.29C4432.76 4847.04 4443.79 4836.01 4457.04 4831.59Z"
                fill="#111111"
            />
            <path
                d="M4556.42 5134.02C4556.42 5125.19 4624.86 4904.44 4624.86 4900.02C4624.86 4897.82 4638.1 4875.74 4651.35 4853.67C4596.16 4798.48 4501.23 4820.55 4459.29 4833.8C4446.04 4838.21 4435.01 4849.25 4428.38 4862.5C4404.1 4924.31 4357.74 4957.42 4373.2 5127.4C4375.4 5156.1 4479.16 5173.76 4567.46 5171.55C4560.84 5151.69 4556.42 5136.23 4556.42 5134.02Z"
                fill="url(#paint18_linear_2599_872)"
            />
            <path
                d="M4688.77 4926.52C4679.94 4888.99 4664.49 4862.5 4644.62 4847.05C4626.96 4891.2 4609.3 4939.76 4611.51 4944.18C4615.93 4953.01 4600.47 5142.86 4598.27 5169.35C4644.62 5164.93 4679.94 5153.9 4688.77 5134.03C4710.85 5067.8 4688.77 4926.52 4688.77 4926.52Z"
                fill="url(#paint19_linear_2599_872)"
            />
            <path
                d="M4368.7 5043.49C4368.7 5065.56 4368.7 5092.05 4373.12 5122.96C4377.53 5169.32 4666.72 5189.19 4688.8 5127.38C4695.42 5109.72 4697.63 5087.64 4697.63 5061.15C4521.02 5074.4 4423.89 5061.15 4368.7 5043.49Z"
                fill="url(#paint20_linear_2599_872)"
            />
            <path
                d="M4861 1493.76C4861 1493.76 4854.38 1630.63 4779.32 1676.99C4779.32 1676.99 5028.77 1824.9 5185.51 1679.2C5185.51 1679.2 5139.15 1606.35 5152.4 1515.84C5165.64 1427.54 4861 1493.76 4861 1493.76Z"
                fill="url(#paint21_linear_2599_872)"
            />
            <path
                d="M5152.46 1518.07C5159.08 1465.09 5121.55 1456.25 5035.46 1467.29C5037.66 1524.69 5042.08 1677.01 4991.3 1736.61C5055.32 1741.03 5123.76 1741.03 5185.57 1685.84C5185.57 1683.63 5139.21 1606.37 5152.46 1518.07Z"
                fill="url(#paint22_linear_2599_872)"
            />
            <path
                d="M5214.27 1220.07C5214.27 1220.07 5227.51 1153.84 5258.42 1178.12C5280.49 1195.78 5251.8 1286.29 5231.93 1323.82C5225.3 1337.06 5209.85 1332.65 5209.85 1332.65L5214.27 1220.07Z"
                fill="url(#paint23_linear_2599_872)"
            />
            <path
                d="M5218.7 1231.13C5218.7 1231.13 5227.53 1189.19 5247.4 1204.64C5260.65 1215.68 5242.99 1273.07 5229.74 1295.15C5225.33 1303.98 5214.29 1299.57 5214.29 1299.57L5218.7 1231.13Z"
                fill="url(#paint24_linear_2599_872)"
            />
            <path
                d="M4779.38 1220.07C4779.38 1220.07 4766.13 1153.84 4735.23 1178.12C4713.15 1195.78 4741.85 1286.29 4761.72 1323.82C4768.34 1337.06 4783.8 1332.65 4783.8 1332.65L4779.38 1220.07Z"
                fill="url(#paint25_linear_2599_872)"
            />
            <path
                d="M4774.98 1231.13C4774.98 1231.13 4766.15 1189.19 4746.28 1204.64C4733.04 1215.68 4750.7 1273.07 4763.95 1295.15C4768.36 1303.98 4779.4 1299.57 4779.4 1299.57L4774.98 1231.13Z"
                fill="url(#paint26_linear_2599_872)"
            />
            <path
                d="M4794.84 986.105L4770.55 1173.75C4770.55 1173.75 4797.04 1405.54 4801.46 1409.96C4805.87 1412.16 4903.01 1544.62 4964.82 1555.65C5028.84 1566.69 5152.46 1502.67 5163.5 1449.69C5174.54 1398.92 5231.93 1116.35 5231.93 1116.35L5240.76 997.143C5240.76 977.275 5218.69 961.822 5201.03 952.992C5141.42 922.086 5000.14 866.898 4854.44 930.916C4816.91 948.577 4799.25 946.369 4794.84 986.105Z"
                fill="url(#paint27_linear_2599_872)"
            />
            <path
                d="M4763.84 1175.87L4770.46 1354.68C4772.67 1398.83 4785.91 1442.98 4810.19 1480.51L4845.51 1551.15C4856.55 1575.44 4874.21 1595.3 4898.5 1608.55C4916.16 1617.38 4936.02 1624 4958.1 1624L5046.4 1615.17C5068.48 1612.96 5094.97 1608.55 5112.63 1595.31C5150.16 1564.4 5167.82 1526.87 5178.86 1491.55C5196.52 1434.15 5260.53 1076.53 5260.53 1076.53L5227.42 1105.23L5163.4 1416.49C5161.19 1423.11 5147.95 1447.4 5136.91 1447.4C5117.04 1447.4 5099.38 1416.49 5086.14 1403.25C5077.31 1394.42 5066.27 1387.8 5057.44 1385.59L4969.14 1372.34C4953.68 1370.13 4936.02 1374.55 4922.78 1385.59L4883.04 1420.91C4883.04 1420.91 4819.02 1418.7 4807.99 1352.47C4796.95 1288.46 4785.91 1158.21 4785.91 1158.21L4763.84 1175.87Z"
                fill="#2B2B2B"
            />
            <path
                d="M5048.73 1445.23L4938.35 1443.02C4936.14 1443.02 4933.93 1447.44 4936.14 1447.44L4984.71 1471.72C4986.91 1473.93 4991.33 1473.93 4993.54 1473.93L5039.9 1465.1C5044.31 1465.1 5046.52 1462.89 5048.73 1458.48L5050.93 1451.85C5055.35 1449.65 5053.14 1445.23 5048.73 1445.23Z"
                fill="url(#paint28_linear_2599_872)"
            />
            <path
                d="M4783.75 1162.67L4847.77 1028.01C4847.77 1028.01 5114.88 1266.42 5253.95 1083.19C5390.82 902.176 5253.95 813.875 5253.95 813.875C5253.95 813.875 5264.99 955.158 4962.56 846.988C4962.56 846.988 4865.43 816.081 4821.27 884.516C4821.27 884.516 4706.48 816.081 4715.31 994.893C4715.31 1012.55 4721.93 1030.21 4728.56 1047.87C4741.8 1074.37 4761.67 1125.14 4763.88 1175.91L4783.75 1162.67Z"
                fill="#2B2B2B"
            />
            <path
                d="M4836.82 924.262C4836.82 924.262 4827.99 809.47 5057.57 955.168C5287.16 1098.66 5289.37 908.808 5289.37 908.808"
                stroke="white"
                strokewidth="1.7177"
                strokemiterlimit="10"
                strokelinecap="round"
                strokelinejoin="round"
            />
            <path
                d="M4836.76 935.251C4836.76 935.251 4810.27 824.873 5059.72 928.627C5309.17 1032.38 5280.48 844.742 5280.48 844.742"
                stroke="#515151"
                strokewidth="1.7177"
                strokemiterlimit="10"
                strokelinecap="round"
                strokelinejoin="round"
            />
            <path
                d="M4827.87 897.745C4827.87 897.745 4810.21 846.972 4836.7 818.273"
                stroke="#2B2B2B"
                strokewidth="1.5"
                strokemiterlimit="10"
                strokelinecap="round"
            />
            <path
                d="M4808.02 908.75C4808.02 908.75 4812.43 853.563 4779.32 833.695"
                stroke="#2B2B2B"
                strokewidth="1.5"
                strokemiterlimit="10"
                strokelinecap="round"
            />
            <path
                d="M4885.46 1308.37C4876.63 1308.37 4867.8 1306.16 4858.97 1303.95C4836.9 1297.33 4821.44 1284.09 4810.4 1266.43C4799.37 1244.35 4799.37 1217.86 4799.37 1191.37V1189.16C4812.61 1173.71 4836.9 1167.09 4863.39 1167.09C4876.63 1167.09 4889.88 1169.29 4903.12 1171.5C4918.58 1173.71 4931.82 1178.12 4940.65 1182.54C4949.48 1186.95 4958.31 1191.37 4964.93 1197.99C4967.14 1215.65 4964.93 1233.31 4958.31 1253.18C4949.48 1277.46 4936.24 1292.92 4918.58 1299.54C4911.95 1306.16 4898.71 1308.37 4885.46 1308.37ZM4808.2 1191.37C4805.99 1217.86 4805.99 1242.14 4817.03 1264.22C4825.86 1281.88 4841.31 1292.92 4861.18 1299.54C4870.01 1301.75 4876.63 1303.95 4885.46 1303.95C4896.5 1303.95 4907.54 1301.75 4918.58 1297.33C4934.03 1290.71 4947.27 1275.26 4956.1 1253.18C4962.73 1235.52 4964.93 1217.86 4962.73 1202.41C4956.1 1195.78 4949.48 1191.37 4940.65 1189.16C4929.61 1184.75 4918.57 1180.33 4905.33 1178.12C4892.08 1175.92 4881.05 1173.71 4870.01 1173.71H4867.8C4850.14 1171.5 4825.86 1175.92 4808.2 1191.37Z"
                fill="#2B2B2B"
            />
            <path
                d="M5064.23 1306.11C5048.77 1297.28 5035.53 1281.83 5026.7 1255.34C5020.07 1235.47 5020.07 1217.81 5022.28 1200.15C5028.9 1193.53 5037.73 1189.12 5046.56 1186.91C5057.6 1182.49 5070.85 1180.29 5086.3 1178.08C5101.75 1175.87 5115 1175.87 5126.04 1175.87C5152.53 1175.87 5174.6 1186.91 5187.85 1202.36V1204.57C5187.85 1231.06 5185.64 1257.55 5172.4 1279.62C5161.36 1297.29 5143.7 1308.32 5121.62 1314.95C5112.79 1317.15 5103.96 1317.15 5095.13 1317.15C5084.09 1314.94 5073.06 1310.53 5064.23 1306.11ZM5126.04 1180.29C5112.79 1180.29 5101.75 1180.28 5088.51 1182.49C5073.05 1184.7 5062.02 1186.91 5050.98 1191.32C5042.15 1193.53 5035.53 1197.94 5028.9 1204.57C5024.49 1220.02 5026.7 1237.68 5033.32 1255.34C5039.94 1277.42 5050.98 1292.87 5066.43 1301.7C5075.26 1306.12 5086.3 1308.32 5097.34 1310.53C5106.17 1310.53 5112.79 1310.53 5121.62 1308.32C5141.49 1303.91 5156.94 1292.87 5167.98 1277.42C5181.23 1257.55 5181.22 1231.06 5181.22 1206.77C5167.98 1186.91 5143.7 1182.49 5126.04 1180.29Z"
                fill="#2B2B2B"
            />
            <path
                d="M5225.35 1191.33C5209.9 1189.12 5194.45 1184.7 5178.99 1180.29C5161.33 1178.08 5145.88 1173.66 5128.22 1173.66C5112.77 1173.66 5095.11 1173.67 5079.65 1175.87C5064.2 1178.08 5048.75 1184.7 5033.3 1191.33C5022.26 1195.74 5009.01 1202.36 4997.98 1202.36C4984.73 1200.16 4973.69 1195.74 4962.65 1189.12C4947.2 1180.29 4933.96 1173.66 4918.5 1171.46C4903.05 1167.04 4885.39 1164.84 4869.94 1164.84C4852.28 1164.84 4836.82 1164.84 4819.16 1167.04C4803.71 1169.25 4788.26 1171.46 4772.8 1173.66C4772.8 1180.29 4772.8 1186.91 4772.8 1195.74C4777.22 1195.74 4781.64 1197.95 4788.26 1200.16C4794.88 1202.36 4801.5 1204.57 4810.33 1206.78C4810.33 1193.53 4823.58 1186.91 4834.62 1182.49C4865.52 1173.66 4900.84 1175.87 4931.75 1184.7C4944.99 1189.12 4958.24 1193.53 4967.07 1206.78C4971.48 1213.4 4973.69 1220.02 4973.69 1228.85C4978.11 1228.85 4980.32 1228.85 4984.73 1228.85C4989.15 1224.44 4995.77 1222.23 5002.39 1222.23C5009.01 1222.23 5017.84 1224.44 5020.05 1228.85C5024.47 1228.85 5026.67 1228.85 5031.09 1228.85C5031.09 1222.23 5033.3 1213.4 5037.71 1208.99C5046.54 1197.95 5061.99 1193.53 5075.24 1189.12C5106.14 1182.5 5141.47 1182.49 5172.37 1193.53C5183.41 1197.95 5196.65 1206.78 5196.65 1220.02C5203.28 1217.82 5209.9 1217.82 5218.73 1215.61C5223.15 1215.61 5227.56 1213.4 5234.18 1213.4C5225.35 1204.57 5225.35 1197.95 5225.35 1191.33Z"
                fill="#2B2B2B"
            />
            <path
                d="M4417.25 3098.75L4260.51 3063.43L4236.23 3246.65L4366.47 3257.69L4417.25 3098.75Z"
                fill="url(#paint29_linear_2599_872)"
            />
            <path
                d="M3960.34 2955.22C4039.82 2959.63 4220.83 2990.54 4320.17 3076.63L4287.06 3070.01C4278.23 3067.8 4267.19 3074.42 4264.99 3083.25L4238.49 3217.92C4236.29 3233.37 4247.33 3248.82 4262.78 3248.82C4262.78 3248.82 4077.34 3308.42 3905.16 3246.61C3821.27 3215.71 3863.21 3072.22 3889.7 2999.37C3905.16 2970.67 3931.65 2953.01 3960.34 2955.22Z"
                fill="#111111"
            />
            <path
                d="M3995.7 2957.42C3982.46 2955.22 3971.42 2955.22 3960.38 2955.22C3931.68 2953.01 3902.99 2970.67 3894.16 2999.37C3867.66 3072.22 3825.72 3215.71 3909.61 3246.61C3918.44 3251.03 3927.27 3253.24 3938.31 3255.44C3894.16 3114.16 3995.7 2957.42 3995.7 2957.42Z"
                fill="url(#paint30_linear_2599_872)"
            />
            <path
                d="M5863.17 3215.68C5863.17 3215.68 5922.78 3610.83 5582.81 3568.89C5304.66 3535.78 4311.27 3290.74 4311.27 3290.74L4359.83 3054.53L5501.13 3125.17C5501.13 3125.17 5863.17 3107.51 5863.17 3215.68Z"
                fill="url(#paint31_linear_2599_872)"
            />
            <path
                d="M4441.61 2314.97C4499.01 2326.01 4543.16 2277.44 4543.16 2277.44L4518.88 2599.74L4763.92 2584.29L5309.18 2529.1C5309.18 2529.1 5419.56 2445.21 5516.69 2462.87C5540.97 2350.29 5622.65 2297.31 5622.65 2297.31C5792.63 2250.95 5847.82 2385.61 5847.82 2385.61C5825.75 2195.76 5770.56 1946.31 5657.97 1873.46C5574.09 1818.27 5390.86 1763.08 5304.76 1738.8C5280.48 1732.18 5260.61 1716.72 5247.37 1696.86C5234.12 1674.78 5212.05 1668.16 5212.05 1668.16C5037.65 1780.74 4779.37 1661.54 4777.16 1661.54C4777.16 1661.54 4582.9 1796.19 4370.97 1899.95C4159.05 2003.7 4223.07 2425.35 4223.07 2425.35C4249.56 2228.87 4379.8 2303.93 4441.61 2314.97Z"
                fill="var(--primary-color)"
            />
            <path
                d="M5540.9 2270.87C5521.04 2487.21 5558.57 2573.3 5558.57 2573.3C5675.57 2469.55 5854.38 2573.3 5854.38 2573.3C5867.62 2533.56 5843.34 2387.87 5843.34 2387.87L5779.32 2244.38L5540.9 2270.87Z"
                fill="var(--primary-color)"
            />
            <path
                d="M4578.52 2259.83C4525.54 2449.68 4521.12 2555.65 4521.12 2555.65C4419.58 2451.89 4225.31 2546.82 4225.31 2546.82C4214.27 2507.08 4225.31 2350.34 4225.31 2350.34L4256.22 2217.89L4578.52 2259.83Z"
                fill="var(--primary-color)"
            />
            <path
                d="M4529.92 2476.14C4342.28 2403.29 4223.07 2489.39 4218.66 2491.59C4218.66 2513.67 4220.86 2533.54 4223.07 2544.58C4223.07 2544.58 4417.34 2449.65 4518.88 2553.4C4521.09 2555.61 4521.09 2529.12 4529.92 2476.14Z"
                fill="#2E4CDB"
            />
            <path
                d="M5545.25 2515.88C5551.87 2555.62 5558.5 2575.48 5558.5 2575.48C5675.5 2471.73 5854.31 2575.48 5854.31 2575.48C5858.72 2560.03 5860.93 2524.71 5858.72 2489.39C5858.72 2489.39 5697.57 2431.99 5545.25 2515.88Z"
                fill="#2E4CDB"
            />
            <path
                d="M4673.32 2939.76L4702.02 2928.72C4721.89 2919.89 4743.97 2917.68 4766.04 2917.68C4768.25 2917.68 4772.66 2917.68 4774.87 2919.89C4783.7 2924.3 4799.16 2933.13 4803.57 2941.96C4810.19 2953 4860.97 3017.02 4814.61 3028.06C4768.25 3039.09 4768.25 3023.64 4726.31 3039.09C4684.36 3054.55 4633.59 3067.8 4629.17 3063.38C4624.76 3058.97 4629.17 3043.51 4629.17 3041.3C4629.17 3041.3 4622.55 2964.04 4673.32 2939.76Z"
                fill="url(#paint32_linear_2599_872)"
            />
            <path
                d="M4803.54 2944.16C4803.54 2944.16 4845.49 2964.02 4860.94 2981.68C4860.94 2981.68 4896.26 2994.93 4887.43 3025.83C4887.43 3025.83 4894.05 3052.32 4883.02 3050.12C4871.98 3050.12 4847.69 3047.91 4843.28 3025.83C4838.86 3003.76 4830.03 2992.72 4812.37 2988.31C4812.37 2988.31 4779.26 2986.1 4788.09 2972.85C4794.71 2957.4 4803.54 2944.16 4803.54 2944.16Z"
                fill="url(#paint33_linear_2599_872)"
            />
            <path
                opacity="0.2"
                d="M4823.41 2955.18C4823.41 2955.18 4847.69 2966.22 4860.94 2981.67C4860.94 2981.67 4896.26 2994.91 4887.43 3025.82C4887.43 3025.82 4894.05 3052.31 4883.02 3050.1C4871.98 3050.1 4847.69 3047.9 4843.28 3025.82C4838.86 3003.74 4830.03 2992.71 4812.37 2988.29C4812.37 2988.29 4779.26 2986.08 4788.09 2972.84C4794.71 2957.39 4823.41 2955.18 4823.41 2955.18Z"
                fill="url(#paint34_linear_2599_872)"
            />
            <path
                d="M4629.17 3023.67C4629.17 3023.67 4626.96 3043.54 4631.38 3058.99C4633.58 3074.44 4642.41 3094.31 4649.04 3098.73C4655.66 3103.14 4673.32 3109.76 4677.74 3109.76C4682.15 3109.76 4695.4 3103.14 4688.77 3089.89C4688.77 3089.89 4679.94 3072.23 4666.7 3070.03C4666.7 3070.03 4673.32 3058.99 4675.53 3043.54C4677.74 3025.88 4629.17 3023.67 4629.17 3023.67Z"
                fill="url(#paint35_linear_2599_872)"
            />
            <path
                d="M4666.73 2981.66C4666.73 2981.66 4644.65 3014.77 4646.86 3021.39C4651.27 3028.02 4708.67 3078.79 4726.33 3087.62C4743.99 3094.24 4757.24 3083.2 4757.24 3083.2C4757.24 3083.2 4766.07 3069.96 4759.44 3065.54C4759.44 3065.54 4704.26 3028.02 4697.63 3019.19L4695.42 2988.28L4666.73 2981.66Z"
                fill="url(#paint36_linear_2599_872)"
            />
            <path
                d="M4743.94 2997.15C4743.94 2997.15 4779.26 3030.26 4785.88 3034.67C4792.51 3041.3 4814.58 3052.33 4812.37 3063.37C4810.17 3074.41 4807.96 3085.45 4781.47 3081.03C4781.47 3081.03 4717.45 3039.09 4697.58 3014.8C4697.58 3014.8 4684.34 2992.73 4684.34 2979.48C4684.34 2970.65 4704.2 2961.82 4715.24 2957.41C4719.66 2955.2 4739.52 2952.99 4739.52 2957.41C4743.94 2977.28 4746.15 2992.73 4743.94 2997.15Z"
                fill="url(#paint37_linear_2599_872)"
            />
            <path
                d="M4786.01 2946.42C4786.01 2946.42 4823.54 2972.91 4832.37 2994.98C4832.37 2994.98 4861.07 3021.47 4867.69 3028.1C4872.11 3032.51 4887.56 3050.17 4878.73 3056.79C4869.9 3063.42 4863.28 3067.83 4852.24 3063.42C4838.99 3059 4827.96 3039.13 4819.13 3034.72C4810.3 3030.3 4766.14 2990.57 4766.14 2990.57C4766.14 2990.57 4746.28 2968.49 4748.48 2964.08C4750.69 2959.66 4779.39 2942 4786.01 2946.42Z"
                fill="url(#paint38_linear_2599_872)"
            />
            <path
                d="M5620.33 2913.28L5591.63 2902.24C5571.76 2893.41 5549.69 2891.2 5527.61 2891.2C5525.41 2891.2 5520.99 2891.2 5518.78 2893.41C5509.95 2897.83 5494.5 2906.66 5490.08 2915.49C5483.46 2926.52 5432.69 2990.54 5479.05 3001.58C5525.41 3012.62 5525.41 2997.17 5567.35 3012.62C5609.29 3028.07 5662.27 3043.52 5662.27 3039.11C5662.27 3032.49 5664.48 3017.03 5664.48 3017.03C5664.48 3017.03 5671.1 2937.56 5620.33 2913.28Z"
                fill="url(#paint39_linear_2599_872)"
            />
            <path
                d="M5490.07 2917.68C5490.07 2917.68 5448.12 2937.55 5432.67 2955.21C5432.67 2955.21 5397.35 2968.45 5406.18 2999.36C5406.18 2999.36 5399.56 3025.85 5412.8 3023.64C5423.84 3023.64 5448.12 3021.44 5452.54 2999.36C5456.95 2979.49 5463.58 2966.25 5483.44 2961.83C5483.44 2961.83 5516.56 2959.62 5507.73 2944.17C5498.9 2930.93 5490.07 2917.68 5490.07 2917.68Z"
                fill="url(#paint40_linear_2599_872)"
            />
            <path
                opacity="0.2"
                d="M5470.2 2928.73C5470.2 2928.73 5445.92 2939.77 5432.67 2955.22C5432.67 2955.22 5397.35 2968.46 5406.18 2999.37C5406.18 2999.37 5399.56 3025.86 5412.8 3023.65C5423.84 3023.65 5448.12 3021.45 5452.54 2999.37C5456.95 2979.5 5463.58 2966.25 5483.44 2961.84C5483.44 2961.84 5516.56 2959.63 5507.73 2944.18C5498.9 2930.94 5470.2 2928.73 5470.2 2928.73Z"
                fill="url(#paint41_linear_2599_872)"
            />
            <path
                d="M5662.24 2979.51C5662.24 2979.51 5664.45 3017.04 5662.24 3032.49C5660.03 3047.94 5651.2 3067.81 5644.58 3072.22C5637.96 3076.64 5620.3 3085.47 5615.88 3083.26C5611.47 3083.26 5598.22 3076.64 5604.84 3063.4C5604.84 3063.4 5613.67 3045.73 5626.92 3043.53C5626.92 3043.53 5622.5 3017.04 5620.3 3001.58C5618.09 2981.72 5662.24 2979.51 5662.24 2979.51Z"
                fill="url(#paint42_linear_2599_872)"
            />
            <path
                d="M5627.02 2955.18C5627.02 2955.18 5649.09 2988.29 5646.88 2994.91C5642.47 3001.54 5585.07 3052.31 5567.41 3061.14C5549.75 3069.97 5536.51 3056.73 5536.51 3056.73C5536.51 3056.73 5527.68 3043.48 5534.3 3039.06C5534.3 3039.06 5589.49 3001.54 5596.11 2990.5L5598.32 2959.59L5627.02 2955.18Z"
                fill="url(#paint43_linear_2599_872)"
            />
            <path
                d="M5549.71 2970.67C5549.71 2970.67 5514.39 3003.78 5507.77 3008.2C5501.15 3014.82 5479.07 3025.85 5481.28 3036.89C5483.49 3047.93 5485.69 3058.97 5512.18 3054.55C5512.18 3054.55 5576.2 3012.61 5596.07 2988.33C5596.07 2988.33 5609.32 2966.25 5609.32 2953.01C5609.32 2944.18 5589.45 2935.35 5578.41 2930.93C5574 2928.72 5554.13 2926.52 5554.13 2930.93C5549.71 2950.8 5547.51 2966.25 5549.71 2970.67Z"
                fill="url(#paint44_linear_2599_872)"
            />
            <path
                d="M5507.73 2919.94C5507.73 2919.94 5470.21 2946.43 5461.38 2968.51C5461.38 2968.51 5434.89 3006.03 5428.26 3014.86C5423.85 3019.28 5408.4 3036.94 5417.23 3043.56C5426.06 3050.19 5432.68 3054.6 5445.92 3050.18C5459.17 3045.77 5470.21 3021.49 5479.04 3010.45C5485.66 3001.62 5529.81 2964.09 5529.81 2964.09C5529.81 2964.09 5549.68 2942.01 5547.47 2937.6C5543.06 2933.18 5514.36 2915.53 5507.73 2919.94Z"
                fill="url(#paint45_linear_2599_872)"
            />
            <path
                d="M5569.52 2824.97H5547.45L3642.33 2778.61L3512.09 1743.27L3542.99 1725.61H5554.07L5569.52 2824.97Z"
                fill="white"
            />
            <path
                d="M5547.45 2824.98L3589.35 2811.73L3512.09 1743.28L5536.41 1747.69L5547.45 2824.98Z"
                fill="#B2B1C0"
            />
            <path
                opacity="0.15"
                d="M4788.01 2820.58L4704.13 2262.07L4370.79 2275.31L4348.71 2816.16L4788.01 2820.58Z"
                fill="#282856"
            />
            <path
                d="M4750.62 3098.72H4415.07C4395.2 3098.72 4375.34 3089.89 4364.3 3074.44C4351.05 3058.99 4346.64 3036.91 4351.05 3017.04L4355.47 2284.14C4359.88 2268.69 4373.13 2257.65 4388.58 2257.65H4708.68L4695.43 3021.46C4688.81 3045.74 4750.62 3098.72 4750.62 3098.72Z"
                fill="#A1A1B2"
            />
            <path
                opacity="0.15"
                d="M4512.15 2716.76C4574.33 2716.76 4624.74 2666.36 4624.74 2604.18C4624.74 2542 4574.33 2491.59 4512.15 2491.59C4449.98 2491.59 4399.57 2542 4399.57 2604.18C4399.57 2666.36 4449.98 2716.76 4512.15 2716.76Z"
                fill="#282856"
            />
            <path
                opacity="0.2"
                d="M4403.98 2610.8C4403.98 2548.99 4454.76 2498.21 4516.57 2498.21C4549.68 2498.21 4578.38 2511.46 4600.46 2535.74C4580.59 2509.25 4547.48 2491.59 4512.15 2491.59C4450.34 2491.59 4399.57 2542.37 4399.57 2604.18C4399.57 2632.88 4410.61 2659.37 4428.27 2679.24C4412.82 2659.37 4403.98 2635.09 4403.98 2610.8Z"
                fill="#282856"
            />
            <path
                opacity="0.2"
                d="M4527.62 2602.05H4503.33C4494.5 2602.05 4487.88 2595.43 4487.88 2586.6V2582.18C4487.88 2573.35 4494.5 2566.73 4503.33 2566.73H4527.62C4536.45 2566.73 4543.07 2573.35 4543.07 2582.18V2586.6C4543.07 2595.43 4536.45 2602.05 4527.62 2602.05Z"
                fill="#282856"
            />
            <path
                d="M4269.29 2917.71C4189.81 3127.43 4099.3 3365.85 3880.76 3387.92C3748.3 3401.17 3644.55 3372.47 3580.53 3306.24C3562.87 3288.58 3538.59 3228.98 3529.76 3211.32H3503.27C3512.1 3231.18 3540.79 3297.41 3562.87 3321.69C3604.81 3365.85 3682.08 3414.41 3816.74 3414.41C3836.61 3414.41 3858.68 3412.2 3882.96 3410C3986.72 3398.96 4072.81 3341.56 4143.46 3235.6C4205.27 3145.09 4249.42 3028.09 4289.15 2924.34C4346.55 2772.01 4410.57 2615.28 4496.66 2595.41C4501.08 2595.41 4503.29 2590.99 4505.49 2586.58C4507.7 2577.75 4501.08 2571.13 4492.25 2573.33C4395.12 2593.2 4328.89 2760.98 4269.29 2917.71Z"
                fill="#818196"
            />
            <path
                d="M3344.32 3025.91H3315.63L2428.19 2961.89L2200.81 1635.15L2242.76 1608.66L3229.53 1602.04L3344.32 3025.91Z"
                fill="white"
            />
            <path
                d="M3315.62 3025.91L2357.55 3010.46L2200.81 1635.16H3205.25L3315.62 3025.91Z"
                fill="#B2B1C0"
            />
            <path
                opacity="0.12"
                d="M2988.86 2849.27L2929.26 2401.14H2633.45L2615.79 2836.03L2988.86 2849.27Z"
                fill="#282856"
            />
            <path
                d="M2891.85 2674.94L2677.71 2677.15C2673.3 2677.15 2668.88 2681.56 2668.88 2685.98L2673.3 2712.47C2673.3 2716.89 2677.71 2719.09 2682.13 2719.09L2896.26 2716.89C2900.68 2716.89 2905.09 2712.47 2905.09 2708.05L2900.68 2681.57C2900.68 2679.36 2896.26 2674.94 2891.85 2674.94Z"
                fill="#818196"
            />
            <path
                d="M2807.89 3101.01H2523.11C2505.45 3101.01 2490 3094.39 2478.96 3081.14C2467.93 3067.89 2463.51 3050.24 2467.93 3032.57L2618.04 2410.04C2620.25 2396.8 2633.49 2387.97 2644.53 2387.97H2916.06L2757.12 3036.99C2754.91 3052.44 2788.02 3072.31 2788.02 3072.31L2807.89 3101.01Z"
                fill="#A1A1B2"
            />
            <path
                d="M3057.3 3101.01H2805.64C2787.98 3101.01 2772.53 3094.39 2761.49 3081.14C2750.45 3067.89 2746.03 3050.24 2750.45 3032.57L2902.77 2399.01C2904.98 2392.38 2911.6 2387.97 2920.43 2387.97C2927.05 2390.18 2931.47 2396.8 2931.47 2405.63L2779.15 3039.2C2776.94 3048.03 2779.15 3059.07 2785.77 3065.69C2790.19 3072.31 2799.02 3074.52 2807.85 3074.52H3035.22L3057.3 3101.01Z"
                fill="white"
            />
            <path
                d="M2763.74 2672.69C2748.29 2747.75 2701.93 2809.56 2662.19 2807.35C2620.25 2807.35 2600.38 2745.54 2615.84 2670.49C2631.29 2595.43 2677.65 2533.62 2717.38 2535.83C2757.12 2538.03 2779.19 2597.64 2763.74 2672.69Z"
                fill="url(#paint46_linear_2599_872)"
            />
            <path
                d="M2760.66 2692.76C2781.24 2618.75 2766.49 2550.02 2727.73 2539.24C2688.96 2528.46 2640.86 2579.72 2620.28 2653.72C2599.7 2727.73 2614.45 2796.46 2653.21 2807.24C2691.98 2818.02 2740.08 2766.76 2760.66 2692.76Z"
                fill="#B2B1C0"
            />
            <path
                d="M2637.9 2672.71C2651.14 2606.48 2688.67 2549.08 2726.2 2538.05C2721.79 2535.84 2719.58 2535.84 2715.16 2535.84C2673.22 2535.84 2626.86 2595.44 2611.41 2670.5C2595.95 2745.56 2618.03 2807.37 2659.97 2807.37C2664.39 2807.37 2668.8 2807.37 2673.22 2805.16C2640.11 2796.33 2624.65 2738.93 2637.9 2672.71Z"
                fill="#818196"
            />
            <path
                d="M2726.17 2699.2C2726.17 2699.2 2750.45 2694.79 2759.28 2694.79L2754.87 2714.65C2754.87 2714.65 2723.96 2719.07 2721.75 2716.86C2708.51 2703.62 2726.17 2699.2 2726.17 2699.2Z"
                fill="#818196"
            />
            <path
                d="M2726.17 2699.2C2726.17 2699.2 2743.83 2694.79 2759.28 2694.79L2754.87 2714.65C2754.87 2714.65 2723.96 2719.07 2721.75 2716.86C2708.51 2703.62 2726.17 2699.2 2726.17 2699.2Z"
                fill="url(#paint47_linear_2599_872)"
            />
            <path
                d="M2894.04 2928.75C2953.64 3085.49 3019.87 3264.3 3183.23 3279.76C3282.57 3290.79 3359.83 3268.72 3408.4 3217.95C3421.65 3204.7 3439.31 3160.55 3445.93 3147.3H3465.8C3459.17 3162.76 3439.31 3211.32 3421.65 3228.98C3390.74 3262.1 3333.34 3299.62 3231.8 3299.62C3216.34 3299.62 3200.89 3299.62 3183.23 3297.42C3105.97 3288.59 3041.95 3246.64 2988.97 3167.17C2942.61 3098.74 2909.49 3012.64 2880.8 2935.38C2836.64 2818.38 2790.29 2716.83 2721.85 2716.83L2726.27 2699.17C2805.74 2699.17 2847.68 2805.13 2894.04 2928.75Z"
                fill="#818196"
            />
            <path
                d="M6863.18 5206.95C6863.18 5198.12 7295.86 5200.33 7556.35 5200.33C7816.84 5200.33 7832.29 5200.33 7832.29 5209.16C7832.29 5217.99 7353.25 5229.03 7092.76 5229.03C6832.27 5229.03 6863.18 5215.78 6863.18 5206.95Z"
                fill="#2C272D"
            />
            <path
                d="M7395.18 4328.36H7704.24L7267.15 4593.27L6924.98 4557.95C6924.98 4557.95 7094.96 4387.96 7395.18 4328.36Z"
                fill="black"
            />
            <path
                d="M7326.84 4350.43L7329.04 4410.04L7463.7 4414.45L7653.55 4328.36H7415.14L7326.84 4350.43Z"
                fill="#2C272D"
            />
            <path
                d="M7205.44 5136.32L7196.61 5134.12L7220.89 5206.97H7229.72H7254.01V5145.15H7209.86L7205.44 5136.32Z"
                fill="#2C272D"
            />
            <path
                d="M7028.8 5134.12L7053.08 5204.76L7061.91 5206.97L7083.99 5204.76L7086.19 5134.12H7037.63H7028.8Z"
                fill="#2C272D"
            />
            <path
                d="M7357.7 5134.1L7370.94 5204.74H7393.02H7401.85L7415.09 5127.48H7406.26L7357.7 5134.1Z"
                fill="#2C272D"
            />
            <path
                d="M7538.84 5140.74L7518.97 5134.12L7521.18 5206.97H7532.21H7554.29L7578.57 5134.12L7538.84 5140.74Z"
                fill="#2C272D"
            />
            <path
                d="M7582.87 5162.81L7704.28 4328.36C7501.19 4350.43 7397.44 4401.21 7238.49 4533.66L7269.4 5162.81H7582.87Z"
                fill="#444247"
            />
            <path
                d="M7267.24 5162.81H7022.2L6896.37 4544.7C7064.14 4423.29 7231.91 4346.02 7395.27 4328.36H7415.14C7214.25 4372.51 7079.59 4434.32 6940.52 4549.11L7238.54 4533.66L7267.24 5162.81Z"
                fill="#4D4B51"
            />
            <path
                d="M3379.64 3248.79H2752.69C2739.45 3248.79 2730.62 3237.75 2730.62 3226.71V3220.09C2730.62 3206.85 2741.65 3198.02 2752.69 3198.02H3379.64C3392.88 3198.02 3401.71 3209.05 3401.71 3220.09V3226.71C3403.92 3237.75 3392.88 3248.79 3379.64 3248.79Z"
                fill="#2C272D"
            />
            <path
                d="M2860.82 5173.79L3044.05 3204.65H3083.78L2909.39 5162.75L2860.82 5173.79Z"
                fill="#2C272D"
            />
            <path
                d="M3309.05 5164.94L3125.82 3198.02H3086.09L3260.48 5156.11L3309.05 5164.94Z"
                fill="#2C272D"
            />
            <path
                d="M6649.03 5175.98L6783.69 3202.43H6821.22L6697.6 5164.94L6649.03 5175.98Z"
                fill="#2C272D"
            />
            <path
                d="M7072.95 5164.94L6887.51 3198.02H6849.98L7024.38 5156.11L7072.95 5164.94Z"
                fill="#2C272D"
            />
            <path
                d="M7541.01 3248.79H6437.24C6423.99 3248.79 6415.16 3237.75 6415.16 3226.71V3220.09C6415.16 3206.85 6426.2 3198.02 6437.24 3198.02H7541.01C7554.26 3198.02 7563.09 3209.05 7563.09 3220.09V3226.71C7565.3 3237.75 7554.26 3248.79 7541.01 3248.79Z"
                fill="#2C272D"
            />
            <path
                d="M7929.49 3204.65H1520.98V3231.14H7929.49V3204.65Z"
                fill="#2C272D"
            />
            <path
                d="M6613.79 3092.13H1520.98V3204.71H6613.79H7929.49V3092.13H6613.79Z"
                fill="#F6BFA4"
            />
            <path
                d="M5675.52 3061.16H4794.7V3092.07H5675.52V3061.16Z"
                fill="white"
            />
            <path
                d="M5659.97 3054.53H5637.9V3058.95H5659.97V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5635.83 3054.53H5613.75V3058.95H5635.83V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5609.26 3054.53H5587.19V3058.95H5609.26V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5582.68 3054.53H5560.6V3058.95H5582.68V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5556.3 3054.53H5534.23V3058.95H5556.3V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5529.76 3054.53H5507.69V3058.95H5529.76V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5505.4 3054.53H5483.33V3058.95H5505.4V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5479.06 3054.53H5456.98V3058.95H5479.06V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5452.44 3054.53H5430.37V3058.95H5452.44V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5426.11 3054.53H5404.03V3058.95H5426.11V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5399.54 3054.53H5377.46V3058.95H5399.54V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5373 3054.53H5350.92V3058.95H5373V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5348.86 3054.53H5326.78V3058.95H5348.86V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5322.24 3054.53H5300.16V3058.95H5322.24V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5295.67 3054.53H5273.59V3058.95H5295.67V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5269.33 3054.53H5247.26V3058.95H5269.33V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5242.77 3054.53H5220.7V3058.95H5242.77V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5218.43 3054.53H5196.35V3058.95H5218.43V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5192.04 3054.53H5169.96V3058.95H5192.04V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5165.47 3054.53H5143.4V3058.95H5165.47V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5139.13 3054.53H5117.05V3058.95H5139.13V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5112.57 3054.53H5090.49V3058.95H5112.57V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5085.98 3054.53H5063.91V3058.95H5085.98V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5061.8 3054.53H5039.73V3058.95H5061.8V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5035.26 3054.53H5013.19V3058.95H5035.26V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M5008.71 3054.53H4986.63V3058.95H5008.71V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M4982.36 3054.53H4960.28V3058.95H4982.36V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M4955.76 3054.53H4933.68V3058.95H4955.76V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M4931.46 3054.53H4909.38V3058.95H4931.46V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M4905.07 3054.53H4882.99V3058.95H4905.07V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M4878.5 3054.53H4856.42V3058.95H4878.5V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M4852.16 3054.53H4830.09V3058.95H4852.16V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M4825.54 3054.53H4803.47V3058.95H4825.54V3054.53Z"
                fill="#D7D7F2"
            />
            <path
                d="M6207.68 3083.27H5971.47L5931.73 2670.46H6247.41L6207.68 3083.27Z"
                fill="white"
            />
            <path
                d="M6218.76 2957.39L6236.42 2778.58H5942.81L5960.47 2955.19L6218.76 2957.39Z"
                fill="#B4B4D1"
            />
            <path
                d="M6260.63 2685.92H5918.46L5927.29 2643.98H6249.59L6260.63 2685.92Z"
                fill="black"
            />
            <path
                d="M6214.31 2655.01H5962.65L5971.48 2604.23H6207.69L6214.31 2655.01Z"
                fill="black"
            />
            <path
                d="M6088.47 2924.32C6057.56 2924.32 6031.07 2897.83 6031.07 2866.93C6031.07 2836.02 6057.56 2809.53 6088.47 2809.53C6119.37 2809.53 6145.86 2836.02 6145.86 2866.93C6145.86 2897.83 6121.58 2924.32 6088.47 2924.32ZM6088.47 2827.19C6066.39 2827.19 6048.73 2844.85 6048.73 2866.93C6048.73 2889 6066.39 2906.66 6088.47 2906.66C6110.54 2906.66 6128.2 2889 6128.2 2866.93C6128.2 2844.85 6110.54 2827.19 6088.47 2827.19Z"
                fill="black"
            />
            <path
                d="M7258.36 2061.24C7216.41 2061.24 7181.09 2025.91 7181.09 1983.97C7181.09 1942.03 7216.41 1906.71 7258.36 1906.71C7300.3 1906.71 7335.62 1942.03 7335.62 1983.97C7335.62 2025.91 7300.3 2061.24 7258.36 2061.24Z"
                fill="#FCBC06"
            />
            <path
                d="M7688.85 3041.32H7680.02V2902.24L7914.02 2398.92L7479.13 1840.41L7510.04 1809.5L7984.66 2396.71L7735.21 2902.24L7688.85 3041.32Z"
                fill="#333333"
            />
            <path
                d="M7949.47 2460.72C7984.83 2460.72 8013.49 2432.06 8013.49 2396.7C8013.49 2361.34 7984.83 2332.68 7949.47 2332.68C7914.12 2332.68 7885.45 2361.34 7885.45 2396.7C7885.45 2432.06 7914.12 2460.72 7949.47 2460.72Z"
                fill="black"
            />
            <path
                d="M7711.06 3072.26H7719.89C7739.75 3072.26 7755.21 3056.81 7755.21 3036.94V2891.25C7755.21 2871.38 7739.75 2855.93 7719.89 2855.93H7711.06C7691.19 2855.93 7675.73 2871.38 7675.73 2891.25V3036.94C7675.73 3056.81 7691.19 3072.26 7711.06 3072.26Z"
                fill="black"
            />
            <path
                d="M7448.19 3089.89H7777.11C7792.57 3089.89 7805.81 3076.65 7805.81 3061.2V3047.95C7805.81 3032.5 7792.57 3019.25 7777.11 3019.25H7448.19C7432.74 3019.25 7419.49 3032.5 7419.49 3047.95V3061.2C7417.28 3076.65 7430.53 3089.89 7448.19 3089.89Z"
                fill="black"
            />
            <path
                d="M7507.92 1875.77L7538.82 1844.87C7547.65 1836.04 7547.65 1820.59 7538.82 1811.76L7534.41 1807.34C7525.58 1798.51 7510.12 1798.51 7501.29 1807.34L7470.39 1838.25C7461.56 1847.08 7461.56 1862.53 7470.39 1871.36L7474.8 1875.77C7483.63 1884.61 7499.09 1884.61 7507.92 1875.77Z"
                fill="#333333"
            />
            <path
                d="M7344.49 1776.42L7419.55 1699.16C7450.46 1666.04 7503.44 1666.04 7536.55 1696.95C7569.66 1727.86 7569.66 1780.84 7538.76 1813.95L7463.7 1891.21C7505.64 1979.51 7492.4 2087.69 7423.97 2162.74L7075.17 1820.57C7148.02 1752.14 7256.19 1736.69 7344.49 1776.42Z"
                fill="var(--surface-500)"
            />
            <path
                d="M7511.23 3018.91H7557.59V2999.04H7511.23V3018.91Z"
                fill="#4B3D70"
            />
            <path
                d="M7324.59 3089.95H6953.72C6940.47 3089.95 6927.23 3078.91 6927.23 3063.46V3032.55C6927.23 3019.31 6938.26 3006.06 6953.72 3006.06H7324.59C7326.79 3006.06 7326.79 3008.27 7326.79 3008.27V3010.48C7326.79 3012.69 7324.59 3012.69 7324.59 3012.69H7276.02V3081.12H7324.59C7326.79 3081.12 7326.79 3083.33 7326.79 3083.33V3085.54C7326.79 3087.74 7326.79 3089.95 7324.59 3089.95Z"
                fill="#41414F"
            />
            <path
                d="M7315.76 3021.52H6951.52V3028.14H7315.76V3021.52Z"
                fill="#B3B3C6"
            />
            <path
                d="M7315.76 3014.87H6951.52V3021.49H7315.76V3014.87Z"
                fill="white"
            />
            <path
                d="M7315.76 3028.15H6951.52V3034.78H7315.76V3028.15Z"
                fill="#D8D6E5"
            />
            <path
                d="M7315.76 3041.32H6951.52V3047.95H7315.76V3041.32Z"
                fill="#B3B3C6"
            />
            <path
                d="M7315.76 3034.69H6951.52V3041.31H7315.76V3034.69Z"
                fill="white"
            />
            <path
                d="M7315.76 3047.97H6951.52V3054.6H7315.76V3047.97Z"
                fill="#D8D6E5"
            />
            <path
                d="M7315.76 3061.27H6951.52V3067.89H7315.76V3061.27Z"
                fill="#B3B3C6"
            />
            <path
                d="M7315.76 3054.63H6951.52V3061.25H7315.76V3054.63Z"
                fill="white"
            />
            <path
                d="M7315.76 3070.06H6951.52V3076.69H7315.76V3070.06Z"
                fill="#D8D6E5"
            />
            <path
                d="M7315.76 3076.7H6951.52V3083.32H7315.76V3076.7Z"
                fill="#D8D6E5"
            />
            <path
                d="M7262.75 3006.04H6991.23C6980.19 3006.04 6971.36 2997.21 6971.36 2988.38V2966.3C6971.36 2955.26 6980.19 2948.64 6991.23 2948.64H7262.75C7264.96 2948.64 7264.96 2948.64 7264.96 2950.85V2953.06C7264.96 2955.26 7264.96 2955.26 7262.75 2955.26H7227.43V3003.83H7262.75C7264.96 3003.83 7264.96 3003.83 7264.96 3006.04H7262.75C7264.96 3006.04 7264.96 3006.04 7262.75 3006.04Z"
                fill="#9C97B2"
            />
            <path
                d="M7256.12 2957.43H6991.21V2961.84H7256.12V2957.43Z"
                fill="#B3B3C6"
            />
            <path
                d="M7256.12 2953.03H6991.21V2957.45H7256.12V2953.03Z"
                fill="white"
            />
            <path
                d="M7256.12 2961.84H6991.21V2966.26H7256.12V2961.84Z"
                fill="#D8D6E5"
            />
            <path
                d="M7256.12 2972.86H6991.21V2977.28H7256.12V2972.86Z"
                fill="#B3B3C6"
            />
            <path
                d="M7256.12 2968.49H6991.21V2972.9H7256.12V2968.49Z"
                fill="white"
            />
            <path
                d="M7256.12 2977.27H6991.21V2981.69H7256.12V2977.27Z"
                fill="#D8D6E5"
            />
            <path
                d="M7256.12 2986.14H6991.21V2990.56H7256.12V2986.14Z"
                fill="#B3B3C6"
            />
            <path
                d="M7256.12 2981.76H6991.21V2986.17H7256.12V2981.76Z"
                fill="white"
            />
            <path
                d="M7256.12 2990.55H6991.21V2994.96H7256.12V2990.55Z"
                fill="#D8D6E5"
            />
            <path
                d="M7256.12 2997.19H6991.21V3001.6H7256.12V2997.19Z"
                fill="#D8D6E5"
            />
            <path
                d="M6872.03 2811.7H6507.78V2842.6H6872.03V2811.7Z"
                fill="white"
            />
            <path
                d="M6377.58 3089.88L6474.71 2802.89L6571.84 3089.88H6377.58Z"
                fill="#3C3C3B"
            />
            <path
                d="M6377.58 3089.88L6474.71 3034.69L6571.84 3089.88H6377.58Z"
                fill="#3C3C3B"
            />
            <path
                d="M6474.67 2802.89V3034.69L6571.8 3089.88L6474.67 2802.89Z"
                fill="#575756"
            />
            <path
                d="M6883.07 2802.89H6474.67L6571.8 3089.88H6980.2L6883.07 2802.89ZM6536.48 2842.63C6527.65 2842.63 6521.03 2836.01 6521.03 2827.18C6521.03 2818.35 6527.65 2811.73 6536.48 2811.73C6545.31 2811.73 6551.94 2818.35 6551.94 2827.18C6551.94 2836.01 6545.31 2842.63 6536.48 2842.63ZM6587.26 2842.63C6578.43 2842.63 6571.8 2836.01 6571.8 2827.18C6571.8 2818.35 6578.43 2811.73 6587.26 2811.73C6596.09 2811.73 6602.71 2818.35 6602.71 2827.18C6602.71 2836.01 6596.09 2842.63 6587.26 2842.63ZM6638.03 2842.63C6629.2 2842.63 6622.58 2836.01 6622.58 2827.18C6622.58 2818.35 6629.2 2811.73 6638.03 2811.73C6646.86 2811.73 6653.48 2818.35 6653.48 2827.18C6653.48 2836.01 6644.65 2842.63 6638.03 2842.63ZM6686.6 2842.63C6677.77 2842.63 6671.14 2836.01 6671.14 2827.18C6671.14 2818.35 6677.77 2811.73 6686.6 2811.73C6695.43 2811.73 6702.05 2818.35 6702.05 2827.18C6702.05 2836.01 6695.43 2842.63 6686.6 2842.63ZM6737.37 2842.63C6728.54 2842.63 6721.92 2836.01 6721.92 2827.18C6721.92 2818.35 6728.54 2811.73 6737.37 2811.73C6746.2 2811.73 6752.82 2818.35 6752.82 2827.18C6752.82 2836.01 6746.2 2842.63 6737.37 2842.63ZM6788.14 2842.63C6779.31 2842.63 6772.69 2836.01 6772.69 2827.18C6772.69 2818.35 6779.31 2811.73 6788.14 2811.73C6796.97 2811.73 6803.6 2818.35 6803.6 2827.18C6803.6 2836.01 6796.97 2842.63 6788.14 2842.63ZM6838.92 2842.63C6830.09 2842.63 6823.46 2836.01 6823.46 2827.18C6823.46 2818.35 6830.09 2811.73 6838.92 2811.73C6847.75 2811.73 6854.37 2818.35 6854.37 2827.18C6854.37 2836.01 6845.54 2842.63 6838.92 2842.63Z"
                fill="var(--surface-500)"
            />
            <path
                d="M6532.11 2833.83C6529.9 2831.62 6527.69 2827.2 6529.9 2822.79C6532.11 2816.17 6532.11 2809.54 6529.9 2805.13C6527.69 2800.71 6529.9 2796.3 6532.11 2794.09C6534.31 2791.88 6540.94 2794.09 6543.14 2800.71C6545.35 2809.54 6545.35 2820.58 6543.14 2829.41C6540.94 2833.82 6534.31 2836.03 6532.11 2833.83Z"
                fill="#454545"
            />
            <path
                d="M6580.76 2833.83C6578.56 2831.62 6576.35 2827.2 6578.55 2822.79C6580.76 2816.17 6580.76 2809.54 6578.55 2805.13C6576.35 2800.71 6578.56 2796.3 6580.76 2794.09C6582.97 2791.88 6589.59 2794.09 6591.8 2800.71C6594.01 2809.54 6594.01 2820.58 6591.8 2829.41C6591.8 2833.82 6585.18 2836.03 6580.76 2833.83Z"
                fill="#454545"
            />
            <path
                d="M6631.45 2833.83C6629.24 2831.62 6627.04 2827.2 6629.24 2822.79C6631.45 2816.17 6631.45 2809.54 6629.24 2805.13C6627.04 2800.71 6629.24 2796.3 6631.45 2794.09C6633.66 2791.88 6640.28 2794.09 6642.49 2800.71C6644.69 2809.54 6644.69 2820.58 6642.49 2829.41C6642.49 2833.82 6635.86 2836.03 6631.45 2833.83Z"
                fill="#454545"
            />
            <path
                d="M6682.15 2833.83C6679.95 2831.62 6677.74 2827.2 6679.95 2822.79C6682.15 2816.17 6682.15 2809.54 6679.95 2805.13C6677.74 2800.71 6679.95 2796.3 6682.15 2794.09C6684.36 2791.88 6690.98 2794.09 6693.19 2800.71C6695.4 2809.54 6695.4 2820.58 6693.19 2829.41C6690.98 2833.82 6684.36 2836.03 6682.15 2833.83Z"
                fill="#454545"
            />
            <path
                d="M6733.06 2833.83C6730.85 2831.62 6728.64 2827.2 6730.85 2822.79C6733.06 2816.17 6733.06 2809.54 6730.85 2805.13C6728.64 2800.71 6730.85 2796.3 6733.06 2794.09C6735.27 2791.88 6741.89 2794.09 6744.1 2800.71C6746.3 2809.54 6746.3 2820.58 6744.1 2829.41C6741.89 2833.82 6735.27 2836.03 6733.06 2833.83Z"
                fill="#454545"
            />
            <path
                d="M6781.49 2833.83C6779.28 2831.62 6777.07 2827.2 6779.28 2822.79C6781.49 2816.17 6781.49 2809.54 6779.28 2805.13C6777.07 2800.71 6779.28 2796.3 6781.49 2794.09C6783.7 2791.88 6790.32 2794.09 6792.53 2800.71C6794.73 2809.54 6794.73 2820.58 6792.53 2829.41C6792.53 2833.82 6785.9 2836.03 6781.49 2833.83Z"
                fill="#454545"
            />
            <path
                d="M6832.39 2833.83C6830.19 2831.62 6827.98 2827.2 6830.19 2822.79C6832.4 2816.17 6832.4 2809.54 6830.19 2805.13C6827.98 2800.71 6830.19 2796.3 6832.39 2794.09C6834.6 2791.88 6841.23 2794.09 6843.43 2800.71C6845.64 2809.54 6845.64 2820.58 6843.43 2829.41C6841.23 2833.82 6836.81 2836.03 6832.39 2833.83Z"
                fill="#454545"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_2599_872"
                    x1="3326.1"
                    y1="893.87"
                    x2="3747.59"
                    y2="893.87"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#111111" />
                    <stop offset="0.9944" stopcolor="#222222" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_2599_872"
                    x1="3592.13"
                    y1="1131.34"
                    x2="3555.5"
                    y2="771.675"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#FAD9D9" />
                    <stop offset="0.9944" stopcolor="#FEABB1" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_2599_872"
                    x1="3515.05"
                    y1="937.336"
                    x2="3367.12"
                    y2="900.752"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#FAD9D9" stopopacity="0" />
                    <stop
                        offset="0.2617"
                        stopcolor="#FCE7E7"
                        stopopacity="0.1308"
                    />
                    <stop
                        offset="0.6879"
                        stopcolor="#FEF9F9"
                        stopopacity="0.3439"
                    />
                    <stop offset="1" stopcolor="white" stopopacity="0.5" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_2599_872"
                    x1="3291.58"
                    y1="586.536"
                    x2="3296.53"
                    y2="409.85"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#FAD4D9" />
                    <stop offset="1" stopcolor="#FEBDC6" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_2599_872"
                    x1="3698.87"
                    y1="499.253"
                    x2="3782.09"
                    y2="504.39"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.4812" stopcolor="#FEABB1" />
                    <stop offset="0.8267" stopcolor="#F48C98" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_2599_872"
                    x1="3405.22"
                    y1="205.856"
                    x2="3740.69"
                    y2="885.07"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#FAD9D9" />
                    <stop offset="0.9944" stopcolor="#FEABB1" />
                </linearGradient>
                <linearGradient
                    id="paint6_linear_2599_872"
                    x1="3305.54"
                    y1="449.223"
                    x2="3738.74"
                    y2="449.223"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.2123" stopcolor="#FEABB1" />
                    <stop offset="1" stopcolor="#F48C98" />
                </linearGradient>
                <linearGradient
                    id="paint7_linear_2599_872"
                    x1="3007.84"
                    y1="5015.87"
                    x2="3150.06"
                    y2="5044.23"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#333333" />
                    <stop offset="1" stopcolor="#111111" />
                </linearGradient>
                <linearGradient
                    id="paint8_linear_2599_872"
                    x1="3323.69"
                    y1="5062.9"
                    x2="3267.18"
                    y2="5064.11"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#333333" />
                    <stop offset="1" stopcolor="#111111" />
                </linearGradient>
                <linearGradient
                    id="paint9_linear_2599_872"
                    x1="3181.16"
                    y1="5227.31"
                    x2="3183.39"
                    y2="5135.73"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#333333" />
                    <stop offset="1" stopcolor="#111111" stopopacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint10_linear_2599_872"
                    x1="3552.58"
                    y1="5022.49"
                    x2="3700.58"
                    y2="5052.02"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#333333" />
                    <stop offset="1" stopcolor="#111111" />
                </linearGradient>
                <linearGradient
                    id="paint11_linear_2599_872"
                    x1="3879.88"
                    y1="5070.68"
                    x2="3821.39"
                    y2="5071.93"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#333333" />
                    <stop offset="1" stopcolor="#111111" />
                </linearGradient>
                <linearGradient
                    id="paint12_linear_2599_872"
                    x1="3732.35"
                    y1="5235.14"
                    x2="3734.58"
                    y2="5143.65"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#333333" />
                    <stop offset="1" stopcolor="#111111" stopopacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint13_linear_2599_872"
                    x1="5629.65"
                    y1="2983.74"
                    x2="5734.36"
                    y2="2536.97"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00558659" stopcolor="#FFC5B6" />
                    <stop offset="0.9944" stopcolor="#F4A997" />
                </linearGradient>
                <linearGradient
                    id="paint14_linear_2599_872"
                    x1="4775.08"
                    y1="2755.13"
                    x2="4229.21"
                    y2="2716.09"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00558659" stopcolor="#FFC5B6" />
                    <stop offset="0.9944" stopcolor="#F4A997" />
                </linearGradient>
                <linearGradient
                    id="paint15_linear_2599_872"
                    x1="5142.68"
                    y1="3324.13"
                    x2="5139.19"
                    y2="3445.13"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#111111" />
                    <stop offset="0.9944" stopcolor="#222222" />
                </linearGradient>
                <linearGradient
                    id="paint16_linear_2599_872"
                    x1="4366.67"
                    y1="4704.22"
                    x2="4685.61"
                    y2="3531.36"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#111111" />
                    <stop offset="0.9944" stopcolor="#222222" />
                </linearGradient>
                <linearGradient
                    id="paint17_linear_2599_872"
                    x1="4451.22"
                    y1="4807.52"
                    x2="4637.63"
                    y2="4807.52"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.2123" stopcolor="#FEABB1" />
                    <stop offset="1" stopcolor="#F48C98" />
                </linearGradient>
                <linearGradient
                    id="paint18_linear_2599_872"
                    x1="4314.82"
                    y1="4949.45"
                    x2="4495.31"
                    y2="4985.45"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#333333" />
                    <stop offset="1" stopcolor="#111111" />
                </linearGradient>
                <linearGradient
                    id="paint19_linear_2599_872"
                    x1="4706.93"
                    y1="5004.03"
                    x2="4637.4"
                    y2="5005.51"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#333333" />
                    <stop offset="1" stopcolor="#111111" />
                </linearGradient>
                <linearGradient
                    id="paint20_linear_2599_872"
                    x1="4531.13"
                    y1="5168.76"
                    x2="4533.35"
                    y2="5077.78"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#333333" />
                    <stop offset="1" stopcolor="#111111" stopopacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint21_linear_2599_872"
                    x1="4779.12"
                    y1="1607.25"
                    x2="5186.17"
                    y2="1607.25"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00558659" stopcolor="#FFC5B6" />
                    <stop offset="0.9944" stopcolor="#F4A997" />
                </linearGradient>
                <linearGradient
                    id="paint22_linear_2599_872"
                    x1="4992.24"
                    y1="1599.93"
                    x2="5186.23"
                    y2="1599.93"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.2179" stopcolor="#EBA896" />
                    <stop offset="1" stopcolor="#DF9683" />
                </linearGradient>
                <linearGradient
                    id="paint23_linear_2599_872"
                    x1="5206.3"
                    y1="1251.95"
                    x2="5268.93"
                    y2="1249.78"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00558659" stopcolor="#FFC5B6" />
                    <stop offset="0.9944" stopcolor="#F4A997" />
                </linearGradient>
                <linearGradient
                    id="paint24_linear_2599_872"
                    x1="5215.82"
                    y1="1251.05"
                    x2="5252.61"
                    y2="1251.05"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#FAD9D9" />
                    <stop offset="1" stopcolor="#FF8B90" />
                </linearGradient>
                <linearGradient
                    id="paint25_linear_2599_872"
                    x1="4787.69"
                    y1="1251.95"
                    x2="4725.06"
                    y2="1249.78"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00558659" stopcolor="#FFC5B6" />
                    <stop offset="0.9944" stopcolor="#F4A997" />
                </linearGradient>
                <linearGradient
                    id="paint26_linear_2599_872"
                    x1="4778.28"
                    y1="1251.05"
                    x2="4741.48"
                    y2="1251.05"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#FAD9D9" />
                    <stop offset="1" stopcolor="#FF8B90" />
                </linearGradient>
                <linearGradient
                    id="paint27_linear_2599_872"
                    x1="4770.76"
                    y1="1230.05"
                    x2="5241.43"
                    y2="1230.05"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00558659" stopcolor="#FFC5B6" />
                    <stop offset="0.9944" stopcolor="#F4A997" />
                </linearGradient>
                <linearGradient
                    id="paint28_linear_2599_872"
                    x1="4995.48"
                    y1="1446.72"
                    x2="4994.51"
                    y2="1470"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00558659" stopcolor="#FFC5B6" />
                    <stop offset="0.9944" stopcolor="#F4A997" />
                </linearGradient>
                <linearGradient
                    id="paint29_linear_2599_872"
                    x1="4337.94"
                    y1="3069.41"
                    x2="4322.39"
                    y2="3252.78"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.2123" stopcolor="#FEABB1" />
                    <stop offset="1" stopcolor="#F48C98" />
                </linearGradient>
                <linearGradient
                    id="paint30_linear_2599_872"
                    x1="3846.62"
                    y1="3073.78"
                    x2="3966.45"
                    y2="3105.84"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#333333" />
                    <stop offset="1" stopcolor="#111111" />
                </linearGradient>
                <linearGradient
                    id="paint31_linear_2599_872"
                    x1="4434.57"
                    y1="3192.36"
                    x2="5767.89"
                    y2="3366.88"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#111111" />
                    <stop offset="0.9944" stopcolor="#222222" />
                </linearGradient>
                <linearGradient
                    id="paint32_linear_2599_872"
                    x1="4714.55"
                    y1="2961.61"
                    x2="4734.91"
                    y2="3043.63"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00558659" stopcolor="#FFC5B6" />
                    <stop offset="0.9944" stopcolor="#F4A997" />
                </linearGradient>
                <linearGradient
                    id="paint33_linear_2599_872"
                    x1="4808.5"
                    y1="2963.22"
                    x2="4867.25"
                    y2="3030.93"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00558659" stopcolor="#FFC5B6" />
                    <stop offset="0.9944" stopcolor="#F4A997" />
                </linearGradient>
                <linearGradient
                    id="paint34_linear_2599_872"
                    x1="4860.84"
                    y1="2971.53"
                    x2="4834.98"
                    y2="3014.86"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#3D0A10" stopopacity="0" />
                    <stop offset="1" stopcolor="#250000" />
                </linearGradient>
                <linearGradient
                    id="paint35_linear_2599_872"
                    x1="4652.98"
                    y1="3029.21"
                    x2="4670.7"
                    y2="3108.7"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00558659" stopcolor="#FFC5B6" />
                    <stop offset="0.9944" stopcolor="#F4A997" />
                </linearGradient>
                <linearGradient
                    id="paint36_linear_2599_872"
                    x1="4672.92"
                    y1="2995.15"
                    x2="4729.2"
                    y2="3094.73"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00558659" stopcolor="#FFC5B6" />
                    <stop offset="0.9944" stopcolor="#F4A997" />
                </linearGradient>
                <linearGradient
                    id="paint37_linear_2599_872"
                    x1="4708.96"
                    y1="2964.03"
                    x2="4772.04"
                    y2="3072.48"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00558659" stopcolor="#FFC5B6" />
                    <stop offset="0.9944" stopcolor="#F4A997" />
                </linearGradient>
                <linearGradient
                    id="paint38_linear_2599_872"
                    x1="4772.24"
                    y1="2954.37"
                    x2="4838.54"
                    y2="3048.55"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00558659" stopcolor="#FFC5B6" />
                    <stop offset="0.9944" stopcolor="#F4A997" />
                </linearGradient>
                <linearGradient
                    id="paint39_linear_2599_872"
                    x1="5584.01"
                    y1="2952.14"
                    x2="5548.82"
                    y2="3029.22"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00558659" stopcolor="#FFC5B6" />
                    <stop offset="0.9944" stopcolor="#F4A997" />
                </linearGradient>
                <linearGradient
                    id="paint40_linear_2599_872"
                    x1="5484.68"
                    y1="2933.79"
                    x2="5426.09"
                    y2="3001.65"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00558659" stopcolor="#FFC5B6" />
                    <stop offset="0.9944" stopcolor="#F4A997" />
                </linearGradient>
                <linearGradient
                    id="paint41_linear_2599_872"
                    x1="5432.36"
                    y1="2942.25"
                    x2="5458.32"
                    y2="2985.52"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#3D0A10" stopopacity="0" />
                    <stop offset="1" stopcolor="#250000" />
                </linearGradient>
                <linearGradient
                    id="paint42_linear_2599_872"
                    x1="5643.75"
                    y1="3003.55"
                    x2="5623.07"
                    y2="3097.46"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00558659" stopcolor="#FFC5B6" />
                    <stop offset="0.9944" stopcolor="#F4A997" />
                </linearGradient>
                <linearGradient
                    id="paint43_linear_2599_872"
                    x1="5620.02"
                    y1="2966.04"
                    x2="5588.9"
                    y2="3020.43"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00558659" stopcolor="#FFC5B6" />
                    <stop offset="0.9944" stopcolor="#F4A997" />
                </linearGradient>
                <linearGradient
                    id="paint44_linear_2599_872"
                    x1="5579.35"
                    y1="2944.13"
                    x2="5539.21"
                    y2="3011.03"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00558659" stopcolor="#FFC5B6" />
                    <stop offset="0.9944" stopcolor="#F4A997" />
                </linearGradient>
                <linearGradient
                    id="paint45_linear_2599_872"
                    x1="5512.97"
                    y1="2943.1"
                    x2="5442.89"
                    y2="3043.16"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00558659" stopcolor="#FFC5B6" />
                    <stop offset="0.9944" stopcolor="#F4A997" />
                </linearGradient>
                <linearGradient
                    id="paint46_linear_2599_872"
                    x1="2512.7"
                    y1="2666.87"
                    x2="2762.9"
                    y2="2674.72"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#D6DFEA" />
                    <stop offset="1" stopcolor="#929498" />
                </linearGradient>
                <linearGradient
                    id="paint47_linear_2599_872"
                    x1="2716.32"
                    y1="2705.19"
                    x2="2757.81"
                    y2="2705.19"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopcolor="#818196" />
                    <stop offset="0.2585" stopcolor="#7B7B90" />
                    <stop offset="0.514" stopcolor="#6F6F84" />
                    <stop offset="0.76" stopcolor="#7B7B90" />
                    <stop offset="1" stopcolor="#818196" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export default loginImage